import { Component, EventEmitter, Inject, Input, OnInit, Output, HostListener, ElementRef, ChangeDetectorRef, ViewChild, TemplateRef, Renderer2, OnDestroy, Optional } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first, debounce } from 'rxjs/operators';
import { Subscription, forkJoin, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { Task, TaskService } from '@app/_components/task';
import { AlertService, AuthenticationService } from '@app/_services';
import { ApiResponse, User } from '@app/_models';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TaskTypeEnum, TaskStatusEnum, PriorityEnum } from '@app/_helpers';
import { auditTime, debounceTime, map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { timeout } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Msg, MsgService } from '@app/_components/msg';
import { Inbox } from '@app/_components/inbox';
import { InboxComponent } from '@app/_components/inbox/inbox/inbox.component';
import { MessageService } from 'primeng/api';
import { TagJoinService } from '@app/_components/_helpers/tag-join/tag-join.service';
import { TagService } from '@app/_components/task/tag/tag.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { NotesChatConfig } from '@app/_components/_shared/notes-chat/notes-chat.component';
import { TemplateService, Template, TemplateTask } from '@app/_components/template';
import { ReservationService } from '@app/_components/reservation';
// import { AITextService } from '@app/_services/ai-text.service';

@Component({
    selector: 'app-task-add',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.css'],
    standalone: false
})
export class TaskComponent implements OnInit, OnDestroy {
	attachedMail: Inbox;
	fromMail = false;
	modalPurpose = '';
	callingMsg: any;
	isModal = false;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doaddAndDontClose = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doUpdateAndDontClose = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	private selectedTagFolderForCreate: any;
	private selectedTagContextForCreate: any;
	private selectedTagForCreate: any;
	private taskTypeCategory: any;
	currentUser: User;
	currentUserSubscription: Subscription;
	notesChatConfig: NotesChatConfig = {
		title: 'Task Notes',
		maxWidth: '100%',
		maxHeight: '500px',
		customClass: '',
		fieldsPosition: 'top',
		showFilters: true,
		showHeader: true,
		showSortOptions: true,
		fillParent: false,
		sortByDate: 'desc',
		allowEdit: true,
		allowDelete: false,
		allowAdd: true,
		emptyNotesText: 'No notes added',
		placeholder: 'Enter remarks',
		theme: 'default',
		maxNoteLength: 1500,
		editButtonText: 'Edit Note',
		deleteButtonText: 'Delete Note',
		cancelButtonText: 'Cancel',
		useRichTextEditor: true,
		noteTypes: [
			{ value: 1, name: 'General', color: '#DCDCDC' },
			{ value: 2, name: 'Action Item', color: '#ffcccc' },
			{ value: 4, name: 'Meeting Notes', color: '#ade061' },
			{ value: 5, name: 'Status Update', color: '#FFFF99' }
		],
		statusOptions: [
			{ value: 0, name: 'Open', color: '#D3D3D3' },
			{ value: 1, name: 'Complete', color: '#90EE90' },
			{ value: 2, name: 'Proposed', color: '#FFE599' },
			{ value: 3, name: 'On Hold', color: '#ADD8E6' },
			{ value: 4, name: 'Cancelled', color: '#F4A6A6' },
			{ value: 5, name: 'In Progress', color: '#FFA500' }
		]
	};
	openingReservation: any = {};
	constructor(
		public router: Router,
		public activatedRoute: ActivatedRoute,
		public taskService: TaskService,
		public alertService: AlertService,
		public location: Location,
		public formBuilder: UntypedFormBuilder,
		public datePipe: DatePipe,
		public messageService: MessageService,
		public msgService: MsgService,
		private dialog: MatDialog,
		private tagJoinService: TagJoinService,
		private tagService: TagService,
		private authenticationService: AuthenticationService,
		public dynamicDialogRef: DynamicDialogRef,
		private elementRef: ElementRef,
		private cdr: ChangeDetectorRef,
		// private aiTextService: AITextService,
		private renderer: Renderer2,
		private templateService: TemplateService,
		private reservationService: ReservationService,
		@Inject(MAT_DIALOG_DATA) data: any,
		@Optional() public dialogRef?: MatDialogRef<TaskComponent>,
		
	) {
		// if we are passing the task object from the taskList so we don't have to query again...
		// currently not using this but keeping for reference.
		this.statuses = taskService.statuses;
		if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state) {
			if (this.router.getCurrentNavigation().extras.state.myTask) {
				this.navigationExtrasTask = this.router.getCurrentNavigation().extras.state.myTask;
			}
		}
		this.isModal = data?.isModal;
		this.taskApi = data?.taskApi;
		this.fromMail = data?.fromMail;
		this.modalPurpose = data?.purpose;
		this.callingMsg = data?.msg;
		this.taskTypeId = data?.taskTypeId;
		this.copyfromtaskid = data?.copyfromtaskid;
		this.selectedTagForCreate = data?.selectedTagForCreate;
		this.taskTypeCategory = data?.taskTypeCategory;
		// Set form title from dialog data if provided
		if (data?.title) {
			this.formTitle = data.title;
		}
		if (this.taskApi) {
			if (this.taskApi.taskId) {
				this.taskId = data.taskApi.taskId;
				// Set up subtask filters
				this.subtaskFilters = {
					parentTaskId: this.taskId
				};
				this.formLoading = true;
				this.initializeTaskObject();
				this.formReadOnly = false;
				this.formBuild();

				this.populateData(false);
			} else {
				if (!this.requestedByUser) {
					this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
						this.currentUser = user;
						this.requestedByUser = this.currentUser;
					});
				}
				this.formBuild();
			}
			return;
		}
		else {
			if (!this.requestedByUser) {
				this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
					this.currentUser = user;
					this.requestedByUser = this.currentUser;
				});
			}
		}
		if (this.modalPurpose === 'createmailtask') {
			this.formBuild();
		}
		if (this.isModal) {
			this.formBuild();
		}
	}



	// taskType
	get taskTypeEnum() { return TaskTypeEnum; }

	// structure
	subscription: Subscription;
	routerLocation = this.location;

	// data
	taskApiResponse: ApiResponse;
	taskApi: any;
	// default taskTypeId is 1 for task, may be changed in implemenations (ie 2 for Ringup)
	taskTypeId: any = 1;
	copyfromtaskid: number;
	public taskId: number;

	// taskApi passed in navigationExtras from taskList but we have to call it different when received
	navigationExtrasTask;


	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	buttonLoading = false;
	formAction: String;
	formReadOnly = false;
	formTitle: String = 'Task';

	isSavingForm: Boolean = false;
  assignedToUser: any;
  requestedByUser: any;
  assignedToTeam: any;
  private isSelectingTeam: boolean = false;
  private teamClearTimeout: any = null;
	showDescriptionEditor: boolean = true;
	isDescriptionFullscreen: boolean = false;
	isGeneratingAIText: boolean = false;
	showMiniDocEditor: boolean = false;
	editorInstanceId: string = 'editor-' + Math.random().toString(36).substr(2, 9);
  showFollowupDatePicker: boolean = false;
  showDueDatePicker: boolean = false;
  showCompletedDatePicker: boolean = false;
	showStatusPicker: boolean = false;
	showNextActionPicker: boolean = false;
	showPriorityPicker: boolean = false;
	showVisibilityPicker: boolean = false;
	subtaskFilters: any = {};
	
	// Inline editing flags
	editingDateToFollowup: boolean = false;
	editingDateDue: boolean = false;
	editingDateCompleted: boolean = false;
	editingHoursEstToComplete: boolean = false;
	editingHoursActualToComplete: boolean = false;
	editingStatus: boolean = false;
	editingNextAction: boolean = false;
	editingPriority: boolean = false;
	editingVisibility: boolean = false;
  showAssignedToTeamPicker: boolean = false;
	showAssignedToUserPicker: boolean = false;
	showRequestedByUserPicker: boolean = false;
	// Flags to prevent clear event from firing when user is selected
	private isSelectingAssignedToUser: boolean = false;
	private isSelectingRequestedByUser: boolean = false;
	showPropertyPicker: boolean = false;
	showReservationPicker: boolean = false;
	selectedProperty: any = null;
	selectedReservation: any = {};
	showEstimatedHoursPicker: boolean = false;
	showActualHoursPicker: boolean = false;
	showParentTaskPicker: boolean = false;
	selectedParentTask: any = null;
	repeatEventAccordionOpen: boolean = false;
	
	// Template support
	templates: Template[] = [];
	selectedTemplate: Template = null;
	templateTasks: TemplateTask[] = [];
	subtaskCompletions: { [key: number]: boolean } = {};
	
	// Overlay elements appended to body
	private followupOverlayElement: HTMLElement | null = null;
	private dueDateOverlayElement: HTMLElement | null = null;
	private completedDateOverlayElement: HTMLElement | null = null;
	
	// Dialog references
	@ViewChild('eventDialogTemplate') eventDialogTemplate: TemplateRef<any>;
	@ViewChild('categoriesDialogTemplate') categoriesDialogTemplate: TemplateRef<any>;
	@ViewChild('tagsDialogTemplate') tagsDialogTemplate: TemplateRef<any>;
	@ViewChild('collaboratorsDialogTemplate') collaboratorsDialogTemplate: TemplateRef<any>;
	@ViewChild('contactDialogTemplate') contactDialogTemplate: TemplateRef<any>;
	@ViewChild('filesDialogTemplate') filesDialogTemplate: TemplateRef<any>;
	
	eventDialogRef: MatDialogRef<any>;
	categoriesDialogRef: MatDialogRef<any>;
	tagsDialogRef: MatDialogRef<any>;
	taskTagList: any[] = [];
	collaboratorsDialogRef: MatDialogRef<any>;
	contactDialogRef: MatDialogRef<any>;
	filesDialogRef: MatDialogRef<any>;


	nextActions = [
		{ value: 1, name: 'Call' },
		{ value: 2, name: 'Call back' },
		{ value: 3, name: 'Event' },
		{ value: 4, name: 'Follow up' },
		{ value: 5, name: 'No Action - FYI/Archive' },
	];

	statuses: any;

	priorities = [
		{ value: 1, name: 'Critical' },
		{ value: 2, name: 'Immediate' },
		{ value: 3, name: 'Important' },
		{ value: 4, name: 'Standard' },
		{ value: 5, name: 'Low' }
	];

	visibilities = [
		{ value: 1, name: 'Public' },
		{ value: 2, name: 'Team' },
		{ value: 3, name: 'Personal' }
	];


	intervalTaskRepeat: any;
	intervalTaskStatus: any;
	timeZones = [
		{ value: 'US/Hawaii', name: 'HST' },
		{ value: 'US/Pacific', name: 'PST' },
		{ value: 'US/Mountain', name: 'MST' },
		{ value: 'US/Central', name: 'CST' },
		{ value: 'US/Eastern', name: 'EST' },
	];


	time = [
		{ value: '12:00 AM', name: '12:00 AM' },
		{ value: '12:15 AM', name: '12:15 AM' },
		{ value: '12:30 AM', name: '12:30 AM' },
		{ value: '12:45 AM', name: '12:45 AM' },
		{ value: '1:00 AM', name: '1:00 AM' },
		{ value: '1:15 AM', name: '1:15 AM' },
		{ value: '1:30 AM', name: '1:30 AM' },
		{ value: '1:45 AM', name: '1:45 AM' },
		{ value: '2:00 AM', name: '2:00 AM' },
		{ value: '2:15 AM', name: '2:15 AM' },
		{ value: '2:30 AM', name: '2:30 AM' },
		{ value: '2:45 AM', name: '2:45 AM' },
		{ value: '3:00 AM', name: '3:00 AM' },
		{ value: '3:15 AM', name: '3:15 AM' },
		{ value: '3:30 AM', name: '3:30 AM' },
		{ value: '3:45 AM', name: '3:45 AM' },
		{ value: '4:00 AM', name: '4:00 AM' },
		{ value: '4:15 AM', name: '4:15 AM' },
		{ value: '4:30 AM', name: '4:30 AM' },
		{ value: '4:45 AM', name: '4:45 AM' },
		{ value: '5:00 AM', name: '5:00 AM' },
		{ value: '5:15 AM', name: '5:15 AM' },
		{ value: '5:30 AM', name: '5:30 AM' },
		{ value: '5:45 AM', name: '5:45 AM' },
		{ value: '6:00 AM', name: '6:00 AM' },
		{ value: '6:15 AM', name: '6:15 AM' },
		{ value: '6:30 AM', name: '6:30 AM' },
		{ value: '6:45 AM', name: '6:45 AM' },
		{ value: '7:00 AM', name: '7:00 AM' },
		{ value: '7:15 AM', name: '7:15 AM' },
		{ value: '7:30 AM', name: '7:30 AM' },
		{ value: '7:45 AM', name: '7:45 AM' },
		{ value: '8:00 AM', name: '8:00 AM' },
		{ value: '8:15 AM', name: '8:15 AM' },
		{ value: '8:30 AM', name: '8:30 AM' },
		{ value: '8:45 AM', name: '8:45 AM' },
		{ value: '9:00 AM', name: '9:00 AM' },
		{ value: '9:15 AM', name: '9:15 AM' },
		{ value: '9:30 AM', name: '9:30 AM' },
		{ value: '9:45 AM', name: '9:45 AM' },
		{ value: '10:00 AM', name: '10:00 AM' },
		{ value: '10:15 AM', name: '10:15 AM' },
		{ value: '10:30 AM', name: '10:30 AM' },
		{ value: '10:45 AM', name: '10:45 AM' },
		{ value: '11:00 AM', name: '11:00 AM' },
		{ value: '11:15 AM', name: '11:15 AM' },
		{ value: '11:30 AM', name: '11:30 AM' },
		{ value: '11:45 AM', name: '11:45 AM' },
		{ value: '', name: '' },
		{ value: '12:00 PM', name: '12:00 PM' },
		{ value: '12:15 PM', name: '12:15 PM' },
		{ value: '12:30 PM', name: '12:30 PM' },
		{ value: '12:45 PM', name: '12:45 PM' },
		{ value: '1:00 PM', name: '1:00 PM' },
		{ value: '1:15 PM', name: '1:15 PM' },
		{ value: '1:30 PM', name: '1:30 PM' },
		{ value: '1:45 PM', name: '1:45 PM' },
		{ value: '2:00 PM', name: '2:00 PM' },
		{ value: '2:15 PM', name: '2:15 PM' },
		{ value: '2:30 PM', name: '2:30 PM' },
		{ value: '2:45 PM', name: '2:45 PM' },
		{ value: '3:00 PM', name: '3:00 PM' },
		{ value: '3:15 PM', name: '3:15 PM' },
		{ value: '3:30 PM', name: '3:30 PM' },
		{ value: '3:45 PM', name: '3:45 PM' },
		{ value: '4:00 PM', name: '4:00 PM' },
		{ value: '4:15 PM', name: '4:15 PM' },
		{ value: '4:30 PM', name: '4:30 PM' },
		{ value: '4:45 PM', name: '4:45 PM' },
		{ value: '5:00 PM', name: '5:00 PM' },
		{ value: '5:15 PM', name: '5:15 PM' },
		{ value: '5:30 PM', name: '5:30 PM' },
		{ value: '5:45 PM', name: '5:45 PM' },
		{ value: '6:00 PM', name: '6:00 PM' },
		{ value: '6:15 PM', name: '6:15 PM' },
		{ value: '6:30 PM', name: '6:30 PM' },
		{ value: '6:45 PM', name: '6:45 PM' },
		{ value: '7:00 PM', name: '7:00 PM' },
		{ value: '7:15 PM', name: '7:15 PM' },
		{ value: '7:30 PM', name: '7:30 PM' },
		{ value: '7:45 PM', name: '7:45 PM' },
		{ value: '8:00 PM', name: '8:00 PM' },
		{ value: '8:15 PM', name: '8:15 PM' },
		{ value: '8:30 PM', name: '8:30 PM' },
		{ value: '8:45 PM', name: '8:45 PM' },
		{ value: '9:00 PM', name: '9:00 PM' },
		{ value: '9:15 PM', name: '9:15 PM' },
		{ value: '9:30 PM', name: '9:30 PM' },
		{ value: '9:45 PM', name: '9:45 PM' },
		{ value: '10:00 PM', name: '10:00 PM' },
		{ value: '10:15 PM', name: '10:15 PM' },
		{ value: '10:30 PM', name: '10:30 PM' },
		{ value: '10:45 PM', name: '10:45 PM' },
		{ value: '11:00 PM', name: '11:00 PM' },
		{ value: '11:15 PM', name: '11:15 PM' },
		{ value: '11:30 PM', name: '11:30 PM' },
		{ value: '11:45 PM', name: '11:45 PM' }
	];


	// assigns
	reservation: any[];
	shortTermRentalId;
	assignedToTeamId;
	assignedToUserId;
	taskUsers: any[];
	taskDocuments: any[];
	// repeats



	// tags
	folderTagId;
	contextTagId;
	goalTagId;
	projectTagId;
	phaseTagId;
	processTagId;
	tags;
	tagId;





	// TODO: pickup here:

	// change shortTermRentalId to shortTermRental child TQ with property data
	// refactor helpers to task component folder
	// refactor listSummaries out of report and into individual components
	// add notes feature
	// add contact feature
	// XX add reservation dropdown child
	// XX change assignedToTeamId to assignedToTeam child TQ with team data
	// XX change assignedToUserId to assignedToUser child TQ with user data
	// XX format dates by adding datepipe
	// XX add and populate	private TaskTagTQ team = null; to taskApi
	// XX add and populate	private TaskTagTQ createdBy = null; to taskApi
	// XX add and populate	private TaskTagTQ owner = null; to taskApi





	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [
			{ type: 'maxlength', message: '35 characters maximum' }
		],
		'priority': [
			{ type: 'maxlength', message: '10 characters maximum' }
		],
		'taskType': [
			{ type: 'required', message: 'taskType is required' },
		],

		'nextAction': [
			{ type: 'required', message: 'Next Action is required' },
		],

		'visibility': [],

		'hoursEstToComplete': [
			{ type: 'maxlength', message: '5 characters maximum' }
		],
		'hoursActualToComplete': [
			{ type: 'maxlength', message: '5 characters maximum' }
		],
		'dateCreated': [
			{ type: 'pattern', message: 'Enter a valid email' },
			{ type: 'maxlength', message: '50 characters maximum' }
		],

		'dateLastUpdated': [
			{ type: 'required', message: 'Taskname is required' },
			{ type: 'minlength', message: 'Taskname must be at least 5 characters long' },
			{ type: 'maxlength', message: 'Taskname cannot be more than 25 characters long' },
			{ type: 'pattern', message: 'Your taskname may contain only numbers and letters' },
			{ type: 'validTaskname', message: 'Your taskname has already been taken' }
		],

		'dateAssigned': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '1 characters maximum' }
		],

		'dateDue': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],
		'dateCompleted': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],


		'dateToFollowup': [
			{ type: 'pattern', message: 'You must accept terms and conditions' }
		],

		'dateNextAvailableVacancy': [
			{ type: 'pattern', message: '' }
		],



		'recurFreq': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '1 characters maximum' }
		],
		'recurInterval': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '3 characters maximum' }
		],
		'recurDayOfMonth': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '3 characters maximum' }
		],
		'recurDayOfWeek': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '3 characters maximum' }
		],
		'recurIntervalOfMonth': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '3 characters maximum' }
		],
		'recurStartDate': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '1 characters maximum' }
		],
		'recurEndDate': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '1 characters maximum' }
		],
		'recurWeekends': [
			{ type: 'pattern', message: 'Numbers only' },
			{ type: 'maxlength', message: '1 characters maximum' }
		],
		'eventStartDate': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],
		'eventStartTime': [],
		'eventEndDate': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],
		'eventEndTime': [],
		'eventLocation': [
			{ type: 'required', message: 'Location is required' },
		],
		'timeZone': []


	};


	ngOnInit() {
		// Load templates
		this.loadTemplates();
		
		// set the params
		this.activatedRoute.queryParams.subscribe(params => {
			if (params['taskTypeId']) {
				this.taskTypeId = params['taskTypeId'];
			}
		});

		const matContainer = this.elementRef.nativeElement.closest('.mat-dialog-container') as HTMLElement;
		if (matContainer) {
			matContainer.style.overflow = 'visible';
		}


		// ensures we see top of page when we navigate to a impl...
		window.scrollTo(0, 0);

		// formAction
		this.formAction = this.router.url.includes('-add') ? 'add'
			: this.router.url.includes('-edit') ? 'edit'
				: this.router.url.includes('-view') ? 'view'
					: 'edit';
		if (this.isModal) {
			this.formAction = '';
		}
		/**
		 *
		 *
		 *
		 * ACTIONS (ADD / EDIT / DETAIL)
		 *
		 */
		try {
			// add
			if (this.formAction === 'add') {
				this.formReadOnly = false;
				this.formBuild();
			}

			// edit
			else if (this.formAction === 'edit') {
				this.subscription = this.activatedRoute.params.subscribe(params => {
					this.taskId = params.taskId; // (+) converts string 'id' to a number
					// Set up subtask filters
					if (this.taskId) {
						this.subtaskFilters = {
							parentTaskId: this.taskId
						};
					}
				});
				this.initializeTaskObject();
				this.formReadOnly = false;
				this.formBuild();
				this.populateData(false);
			}

			// view
			else if (this.formAction === 'view') {
				this.subscription = this.activatedRoute.params.subscribe(params => {
					this.taskId = params.taskId;
					// Set up subtask filters
					if (this.taskId) {
						this.subtaskFilters = {
							parentTaskId: this.taskId
						};
					}
				});
				this.formLoading = true;
				this.initializeTaskObject();
				this.formReadOnly = true;
				this.formBuild();
				this.populateData(false);
			}
			if (this.taskApi && !this.taskApi.taskId) {
				this.formReadOnly = false;
				this.formBuild();
				// Convert date strings to Date objects before patching
				const taskData = this.convertTaskDates(this.taskApi);
				this.form1.patchValue(taskData);
				console.log(this.form1.controls['name'].value);
				//this.taskApi = null; // To Do need to check why this was done
			}

		} catch (error) {
			console.log('Error: ' + error);
		}
		if (this.taskApi && this.taskId) {
			this.formLoading = true;
			this.taskService.findById(this.taskId).pipe(first()).subscribe(
				data => {
					console.log('taskUser serach: ' + JSON.stringify(data));
					let task = data.data.task as Task;
					this.taskApi = task;
					this.initializeTaskObject();
					this.formReadOnly = false;
					this.formBuild();

					this.populateData(false);
					this.loadTaskTags();
				},
				error => {
					this.formLoading = false;
				},
				() => {
					this.formLoading = false;
				}
			);
		}
		if (this.taskId && this.taskApi?.msgId) {
			this.msgService.findById(this.taskApi.msgId).pipe(first()).subscribe(
				data => {
					console.log('taskUser serach: ' + JSON.stringify(data));
					let msgReceived = data.data.msg as any;
					this.attachedMail = msgReceived as Inbox;
				},
				error => {
					// console.log('reports LIST!: ' + JSON.stringify(error));
				},
				() => {
				}
			);
		}
	}

	formBuild() {
		/**
			   *
			   *
			   *
			   * FORM
			   *
			   */

		// TODO:

		// private Boolean isRecurring = null;
		// private Integer recurMax = null;
		// private Integer recurWeekOfMonth = null;
		// private Integer recurDateOfMonth = null;
		// private Integer recurMonthOfYear = null;
		let currentDate = new Date();
		let currentDateDue = new Date();
		currentDate.setDate(currentDate.getDate() + 3);
		currentDateDue.setDate(currentDateDue.getDate() + 5);
		this.form1 = this.formBuilder.group({

			taskId: [this.taskId],
			reservation: this.formBuilder.group({
				reservationId: []
			}),

			property: this.formBuilder.group({
				shortTermRentalId: []
			}),

			name: ['', Validators.required],
			description: [],
			status: [2, Validators.required],
			priority: [4, Validators.required],
			taskType: [this.taskTypeId, Validators.required],
			nextAction: [4, Validators.required],
			visibility: [1],
			hoursEstToComplete: [],
			hoursActualToComplete: [],


			dateCreated: [],
			dateLastUpdated: [],
			dateAssigned: [],
			dateDue: [currentDateDue],
			dateCompleted: [],
			dateNextAvailableVacancy: [],
			dateToFollowup: [currentDate],

			eventStartDate: [],
			eventStartTime: [],
			eventEndDate: [],
			eventEndTime: [],
			eventLocation: [],
			timeZone: ['US/Pacific'],


			teamId: [],
			assignedToUserId: [],
			setAssignedToTagId: [],
			miniDoc: [],
			int_1: [],
			int_2: [],
			int_3: [],
			int_4: [],
			int_5: [],
			int_6: [],
			int_7: [],
			int_8: [],
			int_9: [],
			int_10: [],
			double_1: [],
			double_2: [],
			double_3: [],
			double_4: [],
			double_5: [],
			double_6: [],
			double_7: [],
			double_8: [],
			double_9: [],
			double_10: [],
			str_1: [],
			str_2: [],
			str_3: [],
			str_4: [],
			str_5: [],
			str_6: [],
			str_7: [],
			str_8: [],
			str_9: [],
			str_10: [],
			date_1: [],
			date_2: [],
			date_3: [],
			date_4: [],
			date_5: [],
			date_6: [],
			date_7: [],
			date_8: [],
			date_9: [],
			date_10: [],
			templateId: [],
			isTemplate: [false],
		});
		this.form1.valueChanges.pipe(debounceTime(3000)).subscribe(formData => {
			console.log(this.findInvalidControls());
			// added
			if (!!this.form1 && this.form1.dirty) {
				console.log('ADDING');
				this.form1.markAsPristine(); // prevents update loop
				this.formSave(false, true); // true = isAutoSave
				// To Do: commented auto save for time. it is causing issue for add and update
			} else {
				console.log('DENIED ADD OR UPDATE: Form:' + !!this.form1 + ' FormLoading:' + this.formLoading + ' Dirty:' + this.form1.dirty);
			}
		});

		// Check if description exists when form is built (handle HTML content from TinyMCE)
		const descValue = this.form1.get('description')?.value;
		if (descValue && descValue.trim() !== '' && descValue !== '<p></p>' && descValue !== '<p><br></p>') {
			this.showDescriptionEditor = true;
		}
	}

	formSave(modalclose: any = false, isAutoSave: boolean = false) {
		if (this.modalPurpose && 'createmailtask' === this.modalPurpose) {
			this.form1.value.msgId = this.callingMsg.msgId;
		}
		if (this.taskApi) {
			this.form1.value.msgId = this.taskApi.msgId;
			this.form1.value.parentTaskId = this.taskApi.parentTaskId;
			this.form1.value.jsonChildTask = this.taskApi.jsonChildTask;
			// Use current team if set, otherwise fall back to taskApi.team
			this.form1.value.team = (this.assignedToTeam !== undefined) ? this.assignedToTeam : this.taskApi.team;
			// Use current assignedToTeamId if set, otherwise fall back to assignedToTeam.teamId, then taskApi.teamId
			if (this.assignedToTeamId !== undefined && this.assignedToTeamId !== null) {
				this.form1.value.teamId = this.assignedToTeamId;
			} else if (this.assignedToTeam && this.assignedToTeam.teamId) {
				this.form1.value.teamId = this.assignedToTeam.teamId;
			} else if (this.assignedToTeam === null) {
				// Explicitly cleared
				this.form1.value.teamId = null;
			} else {
				this.form1.value.teamId = this.taskApi.teamId;
			}
			// Use the current assignedToUser if it has been set (even if null), otherwise fall back to taskApi.assignedTo
			// Check if assignedToUser has been explicitly set by checking if it's not undefined
			this.form1.value.assignedTo = (this.assignedToUser !== undefined) ? this.assignedToUser : this.taskApi.assignedTo;
			// Use the current requestedByUser if it has been set (even if null), otherwise fall back to taskApi.requestedBy
			// Prioritize the current requestedByUser value
			if (this.requestedByUser !== undefined) {
				this.form1.value.requestedBy = this.requestedByUser;
			} else if (this.taskApi && this.taskApi.requestedBy) {
				this.form1.value.requestedBy = this.taskApi.requestedBy;
			} else {
				this.form1.value.requestedBy = null;
			}
			console.log('formSave - requestedByUser:', this.requestedByUser);
			console.log('formSave - form1.value.requestedBy:', this.form1.value.requestedBy);
			// Use current assignedToUserId - prioritize from assignedToUser if available, then from this.assignedToUserId, then taskApi
			if (this.assignedToUser && this.assignedToUser.userId) {
				this.form1.value.assignedToUserId = this.assignedToUser.userId;
			} else if (this.assignedToUserId !== undefined && this.assignedToUserId !== null) {
				this.form1.value.assignedToUserId = this.assignedToUserId;
			} else if (this.assignedToUser === null) {
				// Explicitly cleared
				this.form1.value.assignedToUserId = null;
			} else {
				this.form1.value.assignedToUserId = this.taskApi.assignedToUserId;
			}
			this.form1.value.parentTaskId = this.taskApi?.parentTaskId;
			this.form1.value.taskSourceId = this.taskApi?.taskSourceId;
			this.form1.value.visibility = this.taskApi?.visibility;
			this.form1.value.taskSource = this.taskApi?.taskSource;
		}
		else {
			// For new tasks, use the current values
			this.form1.value.assignedTo = this.assignedToUser;
			this.form1.value.requestedBy = this.requestedByUser;
			this.form1.value.team = this.assignedToTeam;
			// Set teamId from assignedToTeamId if available, otherwise from assignedToTeam
			if (this.assignedToTeamId !== undefined && this.assignedToTeamId !== null) {
				this.form1.value.teamId = this.assignedToTeamId;
			} else if (this.assignedToTeam && this.assignedToTeam.teamId) {
				this.form1.value.teamId = this.assignedToTeam.teamId;
			} else {
				this.form1.value.teamId = null;
			}
			this.form1.value.assignedToUserId = this.assignedToUserId;
			this.form1.value.parentTaskId = null;
			this.form1.value.parent = null;
		}
		if (!this.isSavingForm) {
			try {

				// stop here if form is invalid
				if (this.form1.get('name').invalid) {
					console.log('Task-Add INVALID FIELD(S): ' + this.findInvalidControls());
					if (!isAutoSave) {
						this.alertService.error('Please enter a title first before entering any other fields.');
					}
					return;
				}

				// Only show loading indicator for manual saves, not auto-saves
				if (!isAutoSave) {
					this.formLoading = true;
					this.buttonLoading = true;
				}
				if (this.taskId == null) {
					// Format dates before sending to API
					const payload = this.buildPayloadWithFormattedDates(this.form1.value);
					console.log('Task: Saving...' + JSON.stringify(payload));
					this.isSavingForm = true; // Set true to avoid duplicate records being saved at the same time
					if (this.copyfromtaskid) {
						this.taskService.addWithParent(payload, this.copyfromtaskid)
							.pipe(first())
							.subscribe(
								res => {
									this.isSavingForm = false; // Reset it once we get response
									console.log('Task-Add SUCCESS: ' + JSON.stringify(res));
									this.alertService.success(res, true);
									this.taskApiResponse = res;
									this.taskApi = res.data.task;
									this.populateData(false);
									// If this is auto-save (modalclose=false), emit doUpdateAndDontClose to keep dialog open
									// Otherwise emit doAdd which may close the dialog
									if (modalclose) {
										this.doAdd.emit(this.taskApi);
										// Close the dialog if it's a modal
										if (this.isModal && this.dialogRef) {
											this.dialogRef.close(this.taskApi);
										}
									} else {
										this.doUpdateAndDontClose.emit(this.taskApi);
									}
								},
								err => {
									// Do NOT reset isSavingForm or buttonLoading on error — a 504 means the
									// backend may have already saved the task. Keep buttonLoading=true to block
									// re-submit and prevent duplicate task records.
									console.log('Task-Add FAIL: ' + JSON.stringify(err));
									this.alertService.error(err);
								},
								() => {
									this.isSavingForm = false; // Reset it once we get response
									if (!isAutoSave) {
										this.formLoading = false;
										this.buttonLoading = false;
									}
								});
					}
					else {
						this.taskService.add(payload)
							.pipe(first())
							.subscribe(
								res => {
									this.isSavingForm = false; // Reset once we have a confirmed response
									console.log('Task-Add SUCCESS: ' + JSON.stringify(res));
									this.alertService.success(res, true);
									this.taskApiResponse = res;
									this.taskApi = res.data.task;
									this.populateData(false);
									// If this is auto-save (modalclose=false), emit doUpdateAndDontClose to keep dialog open
									// Otherwise emit doAdd which may close the dialog
									if (modalclose) {
										this.doAdd.emit(this.taskApi);
										// Close the dialog if it's a modal
										if (this.isModal && this.dialogRef) {
											this.dialogRef.close(this.taskApi);
										}
									} else {
										this.doUpdateAndDontClose.emit(this.taskApi);
									}

									if (this.selectedTagForCreate) {
										let tagjoinvo = {
											tagId: this.selectedTagForCreate?.data?.tagId,
											tagType: this.selectedTagForCreate?.data?.tagId,
											tagSource: '40',
											tagSourceId: this.taskApi?.taskId
										};
										if (this.taskTypeCategory) {
											let folder = {
												tagId: 33,
												tagType: 33,
												tagSource: '40',
												tagSourceId: this.taskApi?.taskId
											};
											let context = {
												tagId: this.taskTypeCategory,
												tagType: this.taskTypeCategory,
												tagSource: '40',
												tagSourceId: this.taskApi?.taskId
											};
											this.saveTag(folder);
											this.saveTag(context);
										}
										this.saveTag(tagjoinvo);

										this.alertService.success('Task Categories saved', true);
										this.doUpdateAndDontClose.emit(this.taskApi);
									}
								},
								err => {
									// Do NOT reset isSavingForm or buttonLoading on error — a 504 means the
									// backend may have already saved the task. Keep buttonLoading=true to block
									// re-submit and prevent duplicate task records.
									console.log('Task-Add FAIL: ' + JSON.stringify(err));
									this.alertService.error(err);
								},
								() => {
									this.isSavingForm = false; // Reset once we have a confirmed response
									if (!isAutoSave) {
										this.formLoading = false;
										this.buttonLoading = false;
									}
								});
					}

				}
				else {
					// Format dates before sending to API
					const payload = this.buildPayloadWithFormattedDates(this.form1.value);
					console.log('Task: Updating...' + JSON.stringify(payload));
					this.taskService.update(payload)
						.pipe(first())
						.subscribe(
							res => {
								console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
								if (modalclose) {
									this.alertService.success(res, true);
								}
								this.taskApiResponse = res;
								this.taskApi = res.data.task;
								this.populateData(true);
								this.doUpdate.emit(this.taskApi);
								// Close the dialog if it's a modal and modalclose is true
								if (modalclose && this.isModal && this.dialogRef) {
									this.dialogRef.close(this.taskApi);
								}
							},
							err => {
								// Do NOT reset buttonLoading on error — a 504 means the backend may
								// have already updated the task. Keep button disabled to block re-submit.
								console.log('Task-Update FAIL: ' + JSON.stringify(err));
								this.alertService.error(err);
							},
							() => {
								if (!isAutoSave) {
									this.formLoading = false;
									this.buttonLoading = false;
								}
							});
				}
			} catch (error) {
				this.alertService.error(error);
			}
		}
	}


	saveTag(tagjoinvo: { tagId: any; tagType: any; tagSource: string; tagSourceId: any }) {
		this.tagJoinService.addTagJoin(tagjoinvo)
			.subscribe(data => {
			},
				err => {
					this.alertService.error(err);
				},
				() => {
					this.formLoading = false;
				});
	}

	findById(id: number) {
		try {
			this.formLoading = true;
			this.taskService.findById(id)
				.subscribe(
					res => {
						console.log('task-find SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.taskApiResponse = res;
						this.taskApi = res.data.task;
						// Convert date strings to Date objects before patching
						const taskData = this.convertTaskDates(this.taskApi);
						this.form1.patchValue(taskData);
						this.assignedToTeamId = this.taskApi.assignedToTeamId;
					},
					err => {
						console.log('task-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.formLoading = false;
					});

		} catch (error) {
			this.alertService.error(error);
		}
	}


	/*
	   *
	   * call backs from child to parent with changes
	   *
	   */

	setReservation($event) {
		// update the shortTermRental child with the property from the selected reservation
		console.log($event);
		this.shortTermRentalId = $event['shortTermRentalId'];
	}

	onReservationSelected($event: any) {
		this.setReservation($event);
		this.selectedReservation = $event;
		this.showReservationPicker = false;
		this.cdr.detectChanges();
	}

	setShortTermRentalId($event) {
		console.log($event);
		this.shortTermRentalId = $event['shortTermRentalId'];
		// this.form1.controls['shortTermRentalId'].setValue(this.shortTermRentalId);
	}

	onPropertySelected($event: any) {
		// The property-select component emits on completeMethod (typing), not just on selection
		// We need to check if this is an actual property selection vs just typing
		if ($event && typeof $event === 'object' && $event.shortTermRentalId) {
			// Ignore if it's defaulting to 1 (which happens when the form initializes)
			// Only process if it's a different value or if we already have a selected property
			if ($event.shortTermRentalId === 1 && !this.selectedProperty) {
				// Default value 1, ignore it - user is probably still typing
				console.log('Property selection defaulted to 1, ignoring to prevent auto-selection');
				return;
			}
			
			// Valid property selected - create a property object for display
			const propertyObj = {
				shortTermRentalId: $event.shortTermRentalId,
				propertyCode: $event.propertyCode || `Property ${$event.shortTermRentalId}`
			};
			
			this.setShortTermRentalId(propertyObj);
			this.selectedProperty = propertyObj;
			this.showPropertyPicker = false;
			this.cdr.detectChanges();
		}
		// If $event is not a valid property object, don't do anything (user is still typing)
	}

	togglePropertyPicker() {
		this.showPropertyPicker = !this.showPropertyPicker;
		if (this.showPropertyPicker) {
			setTimeout(() => {
				const overlay = this.elementRef.nativeElement.querySelector('.task-status-overlay.user-search-overlay');
				if (overlay) {
					const autocomplete = overlay.querySelector('input');
					if (autocomplete) {
						autocomplete.focus();
					}
				}
			}, 150);
		}
	}

	closePropertyPicker() {
		this.showPropertyPicker = false;
	}

	toggleReservationPicker() {
		this.showReservationPicker = !this.showReservationPicker;
		if (this.showReservationPicker) {
			setTimeout(() => {
				const overlay = this.elementRef.nativeElement.querySelector('.task-status-overlay.user-search-overlay');
				if (overlay) {
					const autocomplete = overlay.querySelector('input');
					if (autocomplete) {
						autocomplete.focus();
					}
				}
			}, 150);
		}
	}

	closeReservationPicker() {
		this.showReservationPicker = false;
	}

	getPropertyDisplayName(property: any): string {
		if (!property) return '';
		return property.propertyCode || property.name || property.shortTermRentalId || '';
	}

	getReservationDisplayName(reservation: any): string {
		if (!reservation) return '';
		
		// Format: "HKH-236 TEST Nov 13-Nov 15 2025"
		const parts: string[] = [];
		
		// Property code (e.g., "HKH-236")
		const propertyCode = reservation.propertyCode || 
			reservation.property?.propertyCode || 
			reservation.shortTermRental?.propertyCode || '';
		if (propertyCode) {
			parts.push(propertyCode);
		}
		
		// Reservation name/summary (e.g., "TEST")
		const reservationName = reservation.name || 
			reservation.summary || 
			reservation.reservationName || '';
		if (reservationName) {
			parts.push(reservationName);
		}
		
		// Date range (e.g., "Nov 13-Nov 15 2025")
		const checkIn = reservation.checkIn || reservation.checkInDate || reservation.startDate;
		const checkOut = reservation.checkOut || reservation.checkOutDate || reservation.endDate;
		
		if (checkIn && checkOut) {
			const checkInDate = checkIn instanceof Date ? checkIn : new Date(checkIn);
			const checkOutDate = checkOut instanceof Date ? checkOut : new Date(checkOut);
			
			if (!isNaN(checkInDate.getTime()) && !isNaN(checkOutDate.getTime())) {
				// Format: "Nov 13-Nov 15 2025"
				const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
				const checkInMonth = monthNames[checkInDate.getMonth()];
				const checkInDay = checkInDate.getDate();
				const checkOutMonth = monthNames[checkOutDate.getMonth()];
				const checkOutDay = checkOutDate.getDate();
				const year = checkOutDate.getFullYear();
				
				// If same month, format as "Nov 13-15 2025", otherwise "Nov 13-Dec 15 2025"
				if (checkInDate.getMonth() === checkOutDate.getMonth() && checkInDate.getFullYear() === checkOutDate.getFullYear()) {
					parts.push(`${checkInMonth} ${checkInDay}-${checkOutDay} ${year}`);
				} else {
					parts.push(`${checkInMonth} ${checkInDay}-${checkOutMonth} ${checkOutDay} ${year}`);
				}
			}
		}
		
		return parts.length > 0 ? parts.join(' ') : (reservation.summary || reservation.reservationId || '');
	}

	getParentTaskDisplayName(task: any): string {
		if (!task) return '';
		return task.name || task.taskId || '';
	}

	toggleParentTaskPicker() {
		this.showParentTaskPicker = !this.showParentTaskPicker;
		if (this.showParentTaskPicker) {
			setTimeout(() => {
				// Find the parent task overlay specifically
				const overlays = this.elementRef.nativeElement.querySelectorAll('.task-status-overlay.user-search-overlay');
				overlays.forEach((overlay: HTMLElement) => {
					// Check if this overlay contains app-task-search (parent task search)
					if (overlay.querySelector('app-task-search')) {
						const autocomplete = overlay.querySelector('input');
						if (autocomplete) {
							(autocomplete as HTMLElement).focus();
						}
					}
				});
			}, 150);
		}
	}

	closeParentTaskPicker() {
		this.showParentTaskPicker = false;
	}

	toggleEstimatedHoursPicker() {
		this.showEstimatedHoursPicker = !this.showEstimatedHoursPicker;
		if (this.showEstimatedHoursPicker) {
			setTimeout(() => {
				const overlay = this.elementRef.nativeElement.querySelector('.task-status-overlay');
				if (overlay) {
					const input = overlay.querySelector('.hours-input');
					if (input) {
						(input as HTMLElement).focus();
					}
				}
			}, 150);
		}
	}

	closeEstimatedHoursPicker() {
		this.showEstimatedHoursPicker = false;
	}

	toggleActualHoursPicker() {
		this.showActualHoursPicker = !this.showActualHoursPicker;
		if (this.showActualHoursPicker) {
			setTimeout(() => {
				const overlay = this.elementRef.nativeElement.querySelector('.task-status-overlay');
				if (overlay) {
					const input = overlay.querySelector('.hours-input');
					if (input) {
						(input as HTMLElement).focus();
					}
				}
			}, 150);
		}
	}

	closeActualHoursPicker() {
		this.showActualHoursPicker = false;
	}



	setTeamId($event) {
		console.log($event);
		this.assignedToTeamId = $event['assignedToTeamId'];
	}

	setAssignedToUserId($event) {
		console.log($event);
		this.assignedToUserId = $event['assignedToUserId'];
	}

	setAssignedToTagId($event) {
		console.log($event);
		this.tagId = $event['tagId'];
	}
	transformDate(date) {
		return this.datePipe.transform(date, 'MM-dd-yyyy');
	}
	
	formatDate(date: any): string {
		if (!date) return '';
		const dateObj = date instanceof Date ? date : new Date(date);
		if (isNaN(dateObj.getTime())) return '';
		return this.datePipe.transform(dateObj, 'M/d/yyyy') || '';
	}
	
	toggleFollowupDatePicker(event?: Event) {
		this.showFollowupDatePicker = !this.showFollowupDatePicker;
		if (this.showFollowupDatePicker) {
			const trigger = event?.target as HTMLElement;
			const triggerElement = trigger?.closest('.task-date-clickable-label') as HTMLElement;
			if (triggerElement) {
				setTimeout(() => this.appendOverlayToBody('followup', triggerElement), 0);
			}
		} else {
			this.removeOverlayFromBody('followup');
		}
	}
	
	closeFollowupDatePicker() {
		this.showFollowupDatePicker = false;
		this.removeOverlayFromBody('followup');
	}
	
	setQuickDate(option: string) {
		const today = new Date();
		let selectedDate = new Date();
		
		switch(option) {
			case 'today':
				selectedDate = new Date(today);
				break;
			case 'tomorrow':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 1);
				break;
			case 'nextWeek':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 7);
				break;
			case 'nextWeekend':
				selectedDate = new Date(today);
				const daysUntilSaturday = 6 - today.getDay();
				selectedDate.setDate(today.getDate() + (daysUntilSaturday > 0 ? daysUntilSaturday : daysUntilSaturday + 7));
				break;
			case 'twoWeeks':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 14);
				break;
			case 'fourWeeks':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 28);
				break;
		}
		
		this.form1.patchValue({ dateToFollowup: selectedDate });
		this.closeFollowupDatePicker();
	}
	
	getDayName(daysFromToday: number): string {
		const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		const date = new Date();
		date.setDate(date.getDate() + daysFromToday);
		return days[date.getDay()];
	}
	
	formatQuickDate(daysFromToday: number): string {
		const date = new Date();
		date.setDate(date.getDate() + daysFromToday);
		return this.datePipe.transform(date, 'd MMM') || '';
	}
	
	getSelectedDate(): Date | null {
		const value = this.form1.get('dateToFollowup').value;
		if (!value) return null;
		return value instanceof Date ? value : new Date(value);
	}
	
	onFollowupDateSelected(date: Date | null) {
		if (date) {
			this.form1.patchValue({ dateToFollowup: date });
			this.closeFollowupDatePicker();
		}
	}
	
	toggleDueDatePicker(event?: Event) {
		this.showDueDatePicker = !this.showDueDatePicker;
		if (this.showDueDatePicker) {
			const trigger = event?.target as HTMLElement;
			const triggerElement = trigger?.closest('.task-date-clickable-label') as HTMLElement;
			if (triggerElement) {
				setTimeout(() => this.appendOverlayToBody('due', triggerElement), 0);
			}
		} else {
			this.removeOverlayFromBody('due');
		}
	}
	
	closeDueDatePicker() {
		this.showDueDatePicker = false;
		this.removeOverlayFromBody('due');
	}
	
	setQuickDateDue(option: string) {
		const today = new Date();
		let selectedDate = new Date();
		
		switch(option) {
			case 'today':
				selectedDate = new Date(today);
				break;
			case 'tomorrow':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 1);
				break;
			case 'nextWeek':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 7);
				break;
			case 'nextWeekend':
				selectedDate = new Date(today);
				const daysUntilSaturday = 6 - today.getDay();
				selectedDate.setDate(today.getDate() + (daysUntilSaturday > 0 ? daysUntilSaturday : daysUntilSaturday + 7));
				break;
			case 'twoWeeks':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 14);
				break;
			case 'fourWeeks':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 28);
				break;
		}
		
		this.form1.patchValue({ dateDue: selectedDate });
		this.closeDueDatePicker();
	}
	
	getSelectedDueDate(): Date | null {
		const value = this.form1.get('dateDue').value;
		if (!value) return null;
		return value instanceof Date ? value : new Date(value);
	}
	
	onDueDateSelected(date: Date | null) {
		if (date) {
			this.form1.patchValue({ dateDue: date });
			this.closeDueDatePicker();
		}
	}
	
	toggleCompletedDatePicker(event?: Event) {
		this.showCompletedDatePicker = !this.showCompletedDatePicker;
		if (this.showCompletedDatePicker) {
			const trigger = event?.target as HTMLElement;
			const triggerElement = trigger?.closest('.task-date-clickable-label') as HTMLElement;
			if (triggerElement) {
				setTimeout(() => this.appendOverlayToBody('completed', triggerElement), 0);
			}
		} else {
			this.removeOverlayFromBody('completed');
		}
	}
	
	closeCompletedDatePicker() {
		this.showCompletedDatePicker = false;
		this.removeOverlayFromBody('completed');
	}
	
	setQuickDateCompleted(option: string) {
		const today = new Date();
		let selectedDate = new Date();
		
		switch(option) {
			case 'today':
				selectedDate = new Date(today);
				break;
			case 'tomorrow':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 1);
				break;
			case 'nextWeek':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 7);
				break;
			case 'nextWeekend':
				selectedDate = new Date(today);
				const daysUntilSaturday = 6 - today.getDay();
				selectedDate.setDate(today.getDate() + (daysUntilSaturday > 0 ? daysUntilSaturday : daysUntilSaturday + 7));
				break;
			case 'twoWeeks':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 14);
				break;
			case 'fourWeeks':
				selectedDate = new Date(today);
				selectedDate.setDate(today.getDate() + 28);
				break;
		}
		
		this.form1.patchValue({ dateCompleted: selectedDate });
		this.closeCompletedDatePicker();
	}
	
	getSelectedCompletedDate(): Date | null {
		const value = this.form1.get('dateCompleted').value;
		if (!value) return null;
		return value instanceof Date ? value : new Date(value);
	}
	
	onCompletedDateSelected(date: Date | null) {
		if (date) {
			this.form1.patchValue({ dateCompleted: date });
			this.closeCompletedDatePicker();
		}
	}
	
	// Helper method to calculate smart positioning based on viewport space
	private calculateOverlayPosition(triggerElement: HTMLElement, overlayElement: HTMLElement): { top: number, left: number, positionAbove: boolean } {
		const rect = triggerElement.getBoundingClientRect();
		const overlayHeight = overlayElement.offsetHeight || 400; // Default height if not yet rendered
		const overlayWidth = overlayElement.offsetWidth || 500; // Default width if not yet rendered
		const viewportHeight = window.innerHeight;
		const viewportWidth = window.innerWidth;
		const gap = 4; // Gap between trigger and overlay
		
		// Calculate available space below and above
		const spaceBelow = viewportHeight - rect.bottom - gap;
		const spaceAbove = rect.top - gap;
		
		// Determine if we should position above or below
		const positionAbove = spaceBelow < overlayHeight && spaceAbove > spaceBelow;
		
		// Calculate top position
		let top: number;
		if (positionAbove) {
			top = rect.top - overlayHeight - gap;
		} else {
			top = rect.bottom + gap;
		}
		
		// Calculate left position (ensure it doesn't go off-screen)
		let left = rect.left;
		if (left + overlayWidth > viewportWidth) {
			left = viewportWidth - overlayWidth - 10; // 10px margin from right edge
		}
		if (left < 10) {
			left = 10; // 10px margin from left edge
		}
		
		return { top, left, positionAbove };
	}

	// Helper methods to append/remove overlays from body
	private appendOverlayToBody(type: 'followup' | 'due' | 'completed', triggerElement: HTMLElement) {
		// Remove any existing overlay of this type
		this.removeOverlayFromBody(type);
		
		// Wait for Angular to render the overlay
		setTimeout(() => {
			// Find the overlay element in the component
			const overlaySelector = `.task-date-overlay[data-overlay-type="${type}"]`;
			const overlayElement = this.elementRef.nativeElement.querySelector(overlaySelector) as HTMLElement;
			
			if (!overlayElement) return;
			
			// Move to body first (not clone, so Angular components stay initialized)
			this.renderer.appendChild(document.body, overlayElement);
			
			// Wait a bit for the overlay to be fully rendered and measured
			setTimeout(() => {
				// Calculate smart position based on viewport space (now with actual dimensions)
				const position = this.calculateOverlayPosition(triggerElement, overlayElement);
				
				// Position the overlay
				overlayElement.style.position = 'fixed';
				overlayElement.style.top = `${position.top}px`;
				overlayElement.style.left = `${position.left}px`;
				overlayElement.style.zIndex = '10000';
				overlayElement.style.display = 'block';
			}, 50);
			
			// Store reference
			if (type === 'followup') {
				this.followupOverlayElement = overlayElement;
			} else if (type === 'due') {
				this.dueDateOverlayElement = overlayElement;
			} else if (type === 'completed') {
				this.completedDateOverlayElement = overlayElement;
			}
		}, 0);
	}
	
	private removeOverlayFromBody(type: 'followup' | 'due' | 'completed') {
		let overlayElement: HTMLElement | null = null;
		
		if (type === 'followup') {
			overlayElement = this.followupOverlayElement;
			this.followupOverlayElement = null;
		} else if (type === 'due') {
			overlayElement = this.dueDateOverlayElement;
			this.dueDateOverlayElement = null;
		} else if (type === 'completed') {
			overlayElement = this.completedDateOverlayElement;
			this.completedDateOverlayElement = null;
		}
		
		if (overlayElement && overlayElement.parentNode) {
			// Reset styles
			overlayElement.style.position = '';
			overlayElement.style.top = '';
			overlayElement.style.left = '';
			overlayElement.style.zIndex = '';
			overlayElement.style.display = 'none';
			
			// Move back to original container (find the trigger element's parent)
			const overlaySelector = `.task-date-clickable-label[data-overlay-type="${type}"]`;
			const container = this.elementRef.nativeElement.querySelector(overlaySelector) || this.elementRef.nativeElement;
			this.renderer.appendChild(container, overlayElement);
		}
	}
	
	ngOnDestroy() {
		// Clean up all overlays
		this.removeOverlayFromBody('followup');
		this.removeOverlayFromBody('due');
		this.removeOverlayFromBody('completed');
		
		// Clean up TinyMCE editors
		if (typeof window !== 'undefined' && (window as any).tinymce) {
			try {
				const editor1 = (window as any).tinymce.get(this.editorInstanceId + '-description');
				if (editor1) {
					editor1.remove();
				}
			} catch (e) {
				// Editor might not exist, ignore
			}
			try {
				const editor2 = (window as any).tinymce.get(this.editorInstanceId + '-miniDoc');
				if (editor2) {
					editor2.remove();
				}
			} catch (e) {
				// Editor might not exist, ignore
			}
			try {
				const editor3 = (window as any).tinymce.get(this.editorInstanceId + '-description-fullscreen');
				if (editor3) {
					editor3.remove();
				}
			} catch (e) {
				// Editor might not exist, ignore
			}
		}
		this.unlockBodyScroll();
	}
	
	toggleStatusPicker(event?: Event) {
		this.showStatusPicker = !this.showStatusPicker;
		if (this.showStatusPicker) {
			setTimeout(() => {
				const trigger = event?.target as HTMLElement;
				const triggerElement = trigger?.closest('.task-date-clickable-label') as HTMLElement;
				if (triggerElement) {
					const overlay = triggerElement.querySelector('.task-status-overlay') as HTMLElement;
					if (overlay) {
						// Wait for overlay to render to get actual dimensions
						setTimeout(() => {
							const position = this.calculateOverlayPosition(triggerElement, overlay);
							overlay.style.top = position.positionAbove ? 'auto' : '100%';
							overlay.style.bottom = position.positionAbove ? '100%' : 'auto';
							overlay.style.left = '0';
							// Adjust left if needed to keep within viewport
							const triggerRect = triggerElement.getBoundingClientRect();
							if (position.left < triggerRect.left) {
								overlay.style.left = `${position.left - triggerRect.left}px`;
							}
						}, 10);
					}
				}
			}, 0);
		}
	}
	
	closeStatusPicker() {
		this.showStatusPicker = false;
	}
	
	selectStatus(statusValue: number) {
		this.form1.patchValue({ status: statusValue });
		this.closeStatusPicker();
	}
	
	getCurrentStatusName(): string {
		const statusValue = this.form1.get('status').value;
		if (statusValue !== null && statusValue !== undefined && this.statuses) {
			const status = this.statuses.find((e: any) => e.value === statusValue);
			return status ? status.name : '';
		}
		return '';
	}
	
	toggleNextActionPicker(event?: Event) {
		this.showNextActionPicker = !this.showNextActionPicker;
		if (this.showNextActionPicker) {
			setTimeout(() => {
				const trigger = event?.target as HTMLElement;
				const triggerElement = trigger?.closest('.task-date-clickable-label') as HTMLElement;
				if (triggerElement) {
					const overlay = triggerElement.querySelector('.task-status-overlay') as HTMLElement;
					if (overlay) {
						// Wait for overlay to render to get actual dimensions
						setTimeout(() => {
							const position = this.calculateOverlayPosition(triggerElement, overlay);
							overlay.style.top = position.positionAbove ? 'auto' : '100%';
							overlay.style.bottom = position.positionAbove ? '100%' : 'auto';
							overlay.style.left = '0';
							// Adjust left if needed to keep within viewport
							const triggerRect = triggerElement.getBoundingClientRect();
							if (position.left < triggerRect.left) {
								overlay.style.left = `${position.left - triggerRect.left}px`;
							}
						}, 10);
					}
				}
			}, 0);
		}
	}
	
	closeNextActionPicker() {
		this.showNextActionPicker = false;
	}
	
	selectNextAction(actionValue: number) {
		this.form1.patchValue({ nextAction: actionValue });
		this.closeNextActionPicker();
	}
	
	getCurrentNextActionName(): string {
		const actionValue = this.form1.get('nextAction').value;
		if (actionValue !== null && actionValue !== undefined && this.nextActions) {
			const action = this.nextActions.find((e: any) => e.value === actionValue);
			return action ? action.name : '';
		}
		return '';
	}
	
	togglePriorityPicker(event?: Event) {
		this.showPriorityPicker = !this.showPriorityPicker;
		if (this.showPriorityPicker) {
			setTimeout(() => {
				const trigger = event?.target as HTMLElement;
				const triggerElement = trigger?.closest('.task-date-clickable-label') as HTMLElement;
				if (triggerElement) {
					const overlay = triggerElement.querySelector('.task-status-overlay') as HTMLElement;
					if (overlay) {
						// Wait for overlay to render to get actual dimensions
						setTimeout(() => {
							const position = this.calculateOverlayPosition(triggerElement, overlay);
							overlay.style.top = position.positionAbove ? 'auto' : '100%';
							overlay.style.bottom = position.positionAbove ? '100%' : 'auto';
							overlay.style.left = '0';
							// Adjust left if needed to keep within viewport
							const triggerRect = triggerElement.getBoundingClientRect();
							if (position.left < triggerRect.left) {
								overlay.style.left = `${position.left - triggerRect.left}px`;
							}
						}, 10);
					}
				}
			}, 0);
		}
	}
	
	closePriorityPicker() {
		this.showPriorityPicker = false;
	}
	
	selectPriority(priorityValue: number) {
		this.form1.patchValue({ priority: priorityValue });
		this.closePriorityPicker();
	}
	
	getCurrentPriorityName(): string {
		const priorityValue = this.form1.get('priority').value;
		if (priorityValue !== null && priorityValue !== undefined && this.priorities) {
			const priority = this.priorities.find((e: any) => e.value === priorityValue);
			return priority ? priority.name : '';
		}
		return '';
	}
	
	toggleVisibilityPicker(event?: Event) {
		this.showVisibilityPicker = !this.showVisibilityPicker;
		if (this.showVisibilityPicker) {
			setTimeout(() => {
				const trigger = event?.target as HTMLElement;
				const triggerElement = trigger?.closest('.task-date-clickable-label') as HTMLElement;
				if (triggerElement) {
					const overlay = triggerElement.querySelector('.task-status-overlay') as HTMLElement;
					if (overlay) {
						// Wait for overlay to render to get actual dimensions
						setTimeout(() => {
							const position = this.calculateOverlayPosition(triggerElement, overlay);
							overlay.style.top = position.positionAbove ? 'auto' : '100%';
							overlay.style.bottom = position.positionAbove ? '100%' : 'auto';
							overlay.style.left = '0';
							// Adjust left if needed to keep within viewport
							const triggerRect = triggerElement.getBoundingClientRect();
							if (position.left < triggerRect.left) {
								overlay.style.left = `${position.left - triggerRect.left}px`;
							}
						}, 10);
					}
				}
			}, 0);
		}
	}
	
	closeVisibilityPicker() {
		this.showVisibilityPicker = false;
	}
	
	selectVisibility(visibilityValue: number) {
		this.form1.patchValue({ visibility: visibilityValue });
		this.closeVisibilityPicker();
	}
	
	getCurrentVisibilityName(): string {
		const visibilityValue = this.form1.get('visibility').value;
		if (visibilityValue !== null && visibilityValue !== undefined && this.visibilities) {
			const visibility = this.visibilities.find((e: any) => e.value === visibilityValue);
			return visibility ? visibility.name : '';
		}
		return '';
	}
	
	// Helper methods for inline editing
	hasFieldValue(fieldName: string): boolean {
		const value = this.form1.get(fieldName)?.value;
		return value !== null && value !== undefined && value !== '';
	}
	
	toggleEditField(fieldName: string) {
		switch(fieldName) {
			case 'dateToFollowup': this.editingDateToFollowup = !this.editingDateToFollowup; break;
			case 'dateDue': this.editingDateDue = !this.editingDateDue; break;
			case 'dateCompleted': this.editingDateCompleted = !this.editingDateCompleted; break;
			case 'hoursEstToComplete': this.editingHoursEstToComplete = !this.editingHoursEstToComplete; break;
			case 'hoursActualToComplete': this.editingHoursActualToComplete = !this.editingHoursActualToComplete; break;
			case 'status': this.editingStatus = !this.editingStatus; break;
			case 'nextAction': this.editingNextAction = !this.editingNextAction; break;
			case 'priority': this.editingPriority = !this.editingPriority; break;
			case 'visibility': this.editingVisibility = !this.editingVisibility; break;
		}
	}
	
	isEditingField(fieldName: string): boolean {
		switch(fieldName) {
			case 'dateToFollowup': return this.editingDateToFollowup;
			case 'dateDue': return this.editingDateDue;
			case 'dateCompleted': return this.editingDateCompleted;
			case 'hoursEstToComplete': return this.editingHoursEstToComplete;
			case 'hoursActualToComplete': return this.editingHoursActualToComplete;
			case 'status': return this.editingStatus;
			case 'nextAction': return this.editingNextAction;
			case 'priority': return this.editingPriority;
			case 'visibility': return this.editingVisibility;
			default: return false;
		}
	}
	
	toggleAssignedToTeamPicker() {
		this.showAssignedToTeamPicker = !this.showAssignedToTeamPicker;
		if (this.showAssignedToTeamPicker) {
			// Focus the search input after overlay opens
			setTimeout(() => {
				const teamSearchComponent = document.querySelector('app-team-search');
				if (teamSearchComponent) {
					const autocomplete = teamSearchComponent.querySelector('input');
					if (autocomplete) {
						autocomplete.focus();
					}
				}
			}, 150);
		}
	}
	
	closeAssignedToTeamPicker() {
		this.showAssignedToTeamPicker = false;
	}
	
	toggleAssignedToUserPicker() {
		this.showAssignedToUserPicker = !this.showAssignedToUserPicker;
		if (this.showAssignedToUserPicker) {
			// Set flag when picker opens to prevent clear event from firing during selection
			this.isSelectingAssignedToUser = true;
			// Focus the search input after overlay opens
			setTimeout(() => {
				// Find the input within the overlay that just opened
				const overlay = this.elementRef.nativeElement.querySelector('.task-status-overlay.user-search-overlay');
				if (overlay) {
					const autocomplete = overlay.querySelector('input');
					if (autocomplete) {
						autocomplete.focus();
					}
				}
			}, 150);
		} else {
			// Reset flag when picker closes (if no selection was made)
			setTimeout(() => {
				if (!this.assignedToUser) {
					this.isSelectingAssignedToUser = false;
				}
			}, 100);
		}
	}
	
	closeAssignedToUserPicker() {
		this.showAssignedToUserPicker = false;
	}
	
	toggleRequestedByUserPicker() {
		this.showRequestedByUserPicker = !this.showRequestedByUserPicker;
		if (this.showRequestedByUserPicker) {
			// Set flag when picker opens to prevent clear event from firing during selection
			this.isSelectingRequestedByUser = true;
			// Focus the search input after overlay opens
			setTimeout(() => {
				// Find all overlays and get the one that's currently visible (requested by)
				const overlays = this.elementRef.nativeElement.querySelectorAll('.task-status-overlay.user-search-overlay');
				if (overlays.length > 0) {
					// Get the last visible overlay (should be the requested by search)
					const overlay = Array.from(overlays).find((el: any) => el.offsetParent !== null) as HTMLElement;
					if (overlay) {
						const autocomplete = overlay.querySelector('input');
						if (autocomplete) {
							autocomplete.focus();
						}
					}
				}
			}, 150);
		} else {
			// Reset flag when picker closes (if no selection was made)
			setTimeout(() => {
				if (!this.requestedByUser) {
					this.isSelectingRequestedByUser = false;
				}
			}, 100);
		}
	}
	
	closeRequestedByUserPicker() {
		this.showRequestedByUserPicker = false;
		// Reset flag after a delay when picker closes
		setTimeout(() => {
			if (!this.isSelectingRequestedByUser) {
				// Only reset if not in selection process
			}
		}, 100);
	}
	
	getUserDisplayName(user: any): string {
		if (!user) return '';
		// Check if it's an object
		if (typeof user === 'object') {
			// First check for fullName
			if (user.fullName) {
				// Extract just the name part if fullName includes email/userId
				const namePart = user.fullName.split(' ').slice(0, 2).join(' ').trim();
				if (namePart) return namePart;
				return user.fullName;
			}
			// Build name from lastName and firstName
			if (user.lastName || user.firstName) {
				const name = `${user.lastName || ''} ${user.firstName || ''}`.trim();
				if (name) return name;
			}
			// Fallback to emailAddress
			if (user.emailAddress) return user.emailAddress;
			// Fallback to name property
			if (user.name) return user.name;
		}
		// If it's a string, return it
		if (typeof user === 'string') return user;
		return '';
	}
	
	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent) {
		const target = event.target as HTMLElement;
		
		if (this.showFollowupDatePicker) {
			const dateFieldWrappers = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			dateFieldWrappers.forEach((wrapper: HTMLElement, index: number) => {
				if (index === 0 && wrapper.contains(target)) {
					found = true;
				}
			});
			// Also check if click is inside the body-appended overlay
			if (this.followupOverlayElement && this.followupOverlayElement.contains(target)) {
				found = true;
			}
			if (!found) {
				this.closeFollowupDatePicker();
			}
		}
		if (this.showDueDatePicker) {
			const dateFieldWrappers = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			dateFieldWrappers.forEach((wrapper: HTMLElement, index: number) => {
				if (index === 1 && wrapper.contains(target)) {
					found = true;
				}
			});
			// Also check if click is inside the body-appended overlay
			if (this.dueDateOverlayElement && this.dueDateOverlayElement.contains(target)) {
				found = true;
			}
			if (!found) {
				this.closeDueDatePicker();
			}
		}
		if (this.showCompletedDatePicker) {
			const dateFieldWrappers = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			dateFieldWrappers.forEach((wrapper: HTMLElement, index: number) => {
				if (index === 2 && wrapper.contains(target)) {
					found = true;
				}
			});
			// Also check if click is inside the body-appended overlay
			if (this.completedDateOverlayElement && this.completedDateOverlayElement.contains(target)) {
				found = true;
			}
			if (!found) {
				this.closeCompletedDatePicker();
			}
		}
		if (this.showStatusPicker) {
			const target = event.target as HTMLElement;
			const statusFields = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			statusFields.forEach((wrapper: HTMLElement) => {
				if (wrapper.querySelector('.pi-tag') && wrapper.contains(target) && wrapper.querySelector('.task-status-overlay')) {
					found = true;
				}
			});
			if (!found) {
				this.closeStatusPicker();
			}
		}
		if (this.showNextActionPicker) {
			const target = event.target as HTMLElement;
			const allFields = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			allFields.forEach((wrapper: HTMLElement) => {
				if (wrapper.querySelector('.task-status-overlay') && wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Next Action') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closeNextActionPicker();
			}
		}
		if (this.showPriorityPicker) {
			const target = event.target as HTMLElement;
			const allFields = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			allFields.forEach((wrapper: HTMLElement) => {
				if (wrapper.querySelector('.task-status-overlay') && wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Priority') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closePriorityPicker();
			}
		}
		if (this.showAssignedToTeamPicker) {
			const target = event.target as HTMLElement;
			const allFields = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			allFields.forEach((wrapper: HTMLElement) => {
				if (wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Assigned To Team') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closeAssignedToTeamPicker();
			}
		}
		if (this.showAssignedToUserPicker) {
			const target = event.target as HTMLElement;
			const allFields = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			allFields.forEach((wrapper: HTMLElement) => {
				if (wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Assigned To Person') {
						found = true;
					}
				}
			});
			// Also check if click is inside the overlay
			const overlays = this.elementRef.nativeElement.querySelectorAll('.task-status-overlay.user-search-overlay');
			overlays.forEach((overlay: HTMLElement) => {
				// Check if this overlay is for assigned to user by checking if it contains app-user-search with #assignedToUserSearch
				if (overlay.contains(target) && overlay.querySelector('app-user-search')) {
					// Check if this is the assigned to user overlay by looking for the specific template reference
					const userSearch = overlay.querySelector('app-user-search');
					if (userSearch) {
						found = true;
					}
				}
			});
			if (!found) {
				this.closeAssignedToUserPicker();
			}
		}
		if (this.showRequestedByUserPicker) {
			const target = event.target as HTMLElement;
			const allFields = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			allFields.forEach((wrapper: HTMLElement) => {
				if (wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Requested By') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closeRequestedByUserPicker();
			}
		}
		if (this.showPropertyPicker) {
			const target = event.target as HTMLElement;
			// Check if click is inside the overlay
			const overlay = this.elementRef.nativeElement.querySelector('.task-status-overlay.user-search-overlay');
			if (overlay && overlay.contains(target)) {
				// Click is inside overlay, don't close
				return;
			}
			// Check if click is on the property field label
			const dateFieldWrappers = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			dateFieldWrappers.forEach((wrapper: HTMLElement) => {
				if (wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Property') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closePropertyPicker();
			}
		}
		if (this.showReservationPicker) {
			const target = event.target as HTMLElement;
			const dateFieldWrappers = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			dateFieldWrappers.forEach((wrapper: HTMLElement) => {
				if (wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Reservation') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closeReservationPicker();
			}
		}
		if (this.showEstimatedHoursPicker) {
			const target = event.target as HTMLElement;
			const dateFieldWrappers = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			dateFieldWrappers.forEach((wrapper: HTMLElement) => {
				if (wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Estimated Hours') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closeEstimatedHoursPicker();
			}
		}
		if (this.showActualHoursPicker) {
			const target = event.target as HTMLElement;
			const dateFieldWrappers = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			dateFieldWrappers.forEach((wrapper: HTMLElement) => {
				if (wrapper.contains(target)) {
					const labelText = wrapper.querySelector('.task-date-label-text')?.textContent?.trim();
					if (labelText === 'Actual Hours') {
						found = true;
					}
				}
			});
			if (!found) {
				this.closeActualHoursPicker();
			}
		}
		if (this.showParentTaskPicker) {
			const target = event.target as HTMLElement;
			// Find all parent task fields (there might be multiple task-date-clickable-label elements)
			const allFields = this.elementRef.nativeElement.querySelectorAll('.task-date-clickable-label');
			let found = false;
			allFields.forEach((field: HTMLElement) => {
				const labelText = field.querySelector('.task-date-label-text')?.textContent?.trim();
				if (labelText === 'Parent Task' && field.contains(target)) {
					found = true;
				}
			});
			// Also check if click is inside the overlay
			const overlays = this.elementRef.nativeElement.querySelectorAll('.task-status-overlay.user-search-overlay');
			overlays.forEach((overlay: HTMLElement) => {
				// Check if this overlay is for parent task by checking if it contains app-task-search
				if (overlay.contains(target) && overlay.querySelector('app-task-search')) {
					found = true;
				}
			});
			if (!found) {
				this.closeParentTaskPicker();
			}
		}
	}
	

	populateData(fromautosave: any) {
		// 1-folder
		// 2-context
		// 3-goal
		// 4-tag
		// 5-project
		// 6-project-phase
		// 7-process
		// patch in data to child components
		if (!fromautosave) {
			// Convert date strings to Date objects before patching
			const taskData = this.convertTaskDates(this.taskApi);
			this.form1.patchValue(taskData);
		}
		
		// Set loading to false after a short delay to ensure UI updates
		setTimeout(() => {
			this.formLoading = false;
		}, 100);
		this.taskTypeId = this.taskApi.taskType;

		this.taskId = (this.taskApi.taskId ? this.taskApi.taskId : '');

		// Set up subtask filters when taskId is available
		if (this.taskId) {
			this.subtaskFilters = {
				parentTaskId: this.taskId
			};
		} else {
			this.subtaskFilters = {};
		}

		// Load subtasks if templateId is set
		const templateId = this.form1.get('templateId')?.value || this.taskApi?.templateId;
		// if (templateId && this.taskId) {
		if (templateId) {
			this.loadTaskSubtasks();
		}

		// assigns
		this.shortTermRentalId = (this.taskApi.property ? this.taskApi.property.shortTermRentalId : '');
		this.assignedToTeamId = (this.taskApi.team ? this.taskApi.team.teamId : '');
		this.assignedToTeam = (this.taskApi.team ? this.taskApi.team : null);
		this.assignedToUserId = (this.taskApi.assignedTo ? this.taskApi.assignedTo.userId : '');
		// Ensure assignedToUser is properly set and has display properties
		if (this.taskApi.assignedTo) {
			// Create a copy to ensure Angular detects changes
			const userCopy = { ...this.taskApi.assignedTo };
			// Ensure all display properties are set
			if (!userCopy.lastName) userCopy.lastName = '';
			if (!userCopy.firstName) userCopy.firstName = '';
			// Build fullName with only name (no ID or email) for display
			const nameParts = [];
			if (userCopy.lastName) nameParts.push(userCopy.lastName);
			if (userCopy.firstName) nameParts.push(userCopy.firstName);
			userCopy.fullName = nameParts.length > 0 
				? nameParts.join(' ').trim()
				: (userCopy.emailAddress || userCopy.userId?.toString() || '');
			this.assignedToUser = userCopy;
		} else {
			this.assignedToUser = null;
		}
		// Ensure requestedByUser is properly set and has display properties
		if (this.taskApi.requestedBy) {
			// Create a copy to ensure Angular detects changes
			const userCopy = { ...this.taskApi.requestedBy };
			// Ensure all display properties are set
			if (!userCopy.lastName) userCopy.lastName = '';
			if (!userCopy.firstName) userCopy.firstName = '';
			// Build fullName with only name (no ID or email) for display
			const nameParts = [];
			if (userCopy.lastName) nameParts.push(userCopy.lastName);
			if (userCopy.firstName) nameParts.push(userCopy.firstName);
			userCopy.fullName = nameParts.length > 0 
				? nameParts.join(' ').trim()
				: (userCopy.emailAddress || userCopy.userId?.toString() || '');
			this.requestedByUser = userCopy;
		} else {
			this.requestedByUser = null;
		}
		this.taskUsers = (this.taskApi.taskUsers ? this.taskApi.taskUsers : []);
		// Load parent task - check both parent and parentTask properties
		// Create a new object reference to ensure Angular detects the change
		const parentTask = this.taskApi.parentTask || this.taskApi.parent;
		if (parentTask) {
			// Create a copy to ensure Angular change detection
			this.selectedParentTask = { ...parentTask };
		} else {
			this.selectedParentTask = null;
		}
		// If we have parentTaskId but no parent task object, fetch it from the API
		if (!this.selectedParentTask && this.taskApi.parentTaskId) {
			this.fetchParentTask(this.taskApi.parentTaskId);
		}
		
		// Load reservation - create a new object reference to ensure Angular detects the change
		if (this.taskApi.reservation) {
			this.selectedReservation = { ...this.taskApi.reservation };
		} else {
			this.selectedReservation = {};
		}
		
		// Force change detection to update the UI
		// Use setTimeout to defer change detection until after initial change detection cycle
		setTimeout(() => {
			this.cdr.detectChanges();
		}, 0);

		// tags
		this.tags = (this.taskApi.tags ? this.taskApi.tags : '');
		this.folderTagId = (this.taskApi.folder ? this.taskApi.folder.tagId : '');
		this.contextTagId = (this.taskApi.context ? this.taskApi.context.tagId : '');
		this.goalTagId = (this.taskApi.goal ? this.taskApi.goal.tagId : '');
		this.projectTagId = (this.taskApi.project ? this.taskApi.project.tagId : '');
		this.phaseTagId = (this.taskApi.phase ? this.taskApi.phase.tagId : '');
		this.processTagId = (this.taskApi.process ? this.taskApi.process.tagId : '');

		// event
		this.intervalTaskRepeat = (this.taskApi.intervalTaskRepeat ? this.taskApi.intervalTaskRepeat : '');
		this.intervalTaskStatus = (this.taskApi.intervalTaskStatus ? this.taskApi.intervalTaskStatus : '');

		// set time to blank if null so it defaults to middle of drop down select
		if (!this.form1.controls['eventStartTime'].value) {
			this.form1.controls['eventStartTime'].setValue('');
		}
		if (!this.form1.controls['eventEndTime'].value) {
			this.form1.controls['eventEndTime'].setValue('');
		}

		// documents
		this.taskDocuments = (this.taskApi.taskDocuments ? this.taskApi.taskDocuments : []);

		// Show description editor if description exists (handle HTML content from TinyMCE)
		const description = this.taskApi.description;
		if (description && description.trim() !== '' && description !== '<p></p>' && description !== '<p><br></p>') {
			this.showDescriptionEditor = true;
		}

		// Show mini doc editor if miniDoc exists (handle HTML content from TinyMCE)
		const miniDoc = this.taskApi.miniDoc;
		if (miniDoc && miniDoc.trim() !== '' && miniDoc !== '<p></p>' && miniDoc !== '<p><br></p>') {
			this.showMiniDocEditor = true;
		}

	}

	openDescriptionEditor() {
		this.showDescriptionEditor = true;
	}

	openDescriptionFullscreen() {
		this.isDescriptionFullscreen = true;
		this.lockBodyScroll();
	}

	closeDescriptionFullscreen() {
		this.isDescriptionFullscreen = false;
		this.unlockBodyScroll();
	}

	@HostListener('document:keydown.escape', ['$event'])
	onEscapePressed(event: KeyboardEvent) {
		if (this.isDescriptionFullscreen) {
			event.preventDefault();
			this.closeDescriptionFullscreen();
		}
	}

	private lockBodyScroll() {
		if (typeof document !== 'undefined') {
			this.renderer.setStyle(document.body, 'overflow', 'hidden');
		}
	}

	private unlockBodyScroll() {
		if (typeof document !== 'undefined') {
			this.renderer.removeStyle(document.body, 'overflow');
		}
	}
	openMiniDocEditor() {
		this.showMiniDocEditor = true;
	}

	// generateDescriptionWithAI() {
	// 	const taskName = this.form1.get('name')?.value || '';
	// 	if (!taskName || taskName.trim() === '') {
	// 		this.alertService.error('Please enter a task name first to generate a description.');
	// 		return;
	// 	}

	// 	this.isGeneratingAIText = true;
	// 	this.showDescriptionEditor = true; // Ensure editor is open

	// 	// Get current description as context
	// 	const currentDescription = this.form1.get('description')?.value || '';

	// 	// Build full task data context for AI (includes property, reservation, assignedTo, etc.)
	// 	const taskData = {
	// 		property: this.selectedProperty || this.taskApi?.property || null,
	// 		reservation: this.selectedReservation || this.taskApi?.reservation || null,
	// 		assignedTo: this.assignedToUser || this.taskApi?.assignedTo || null,
	// 		priority: this.form1.get('priority')?.value || this.taskApi?.priority || null,
	// 		status: this.form1.get('status')?.value || this.taskApi?.status || null,
	// 		hoursEstToComplete: this.form1.get('hoursEstToComplete')?.value || this.taskApi?.hoursEstToComplete || null,
	// 		hoursActualToComplete: this.form1.get('hoursActualToComplete')?.value || this.taskApi?.hoursActualToComplete || null
	// 	};

	// 	// Generate description using AI with full task context
	// 	this.aiTextService.generateTaskDescription(taskName, currentDescription, taskData).subscribe({
	// 		next: (generatedText: string) => {
	// 			this.isGeneratingAIText = false;
	// 			if (generatedText && generatedText.trim() !== '') {
	// 				// Get current description
	// 				const existingDescription = this.form1.get('description')?.value || '';
					
	// 				// Clean the generated text (remove any HTML tags if present, or format it)
	// 				let cleanText = generatedText.trim();
					
	// 				// If there's existing description, append the AI-generated text
	// 				if (existingDescription && existingDescription.trim() !== '' && 
	// 					existingDescription !== '<p></p>' && existingDescription !== '<p><br></p>') {
	// 					// Append to existing description
	// 					const newDescription = existingDescription + '<p>' + cleanText + '</p>';
	// 					this.form1.patchValue({ description: newDescription });
	// 				} else {
	// 					// Set as new description
	// 					this.form1.patchValue({ description: '<p>' + cleanText + '</p>' });
	// 				}
					
	// 				this.alertService.success('AI description generated successfully!');
	// 				this.cdr.detectChanges();
	// 			} else {
	// 				this.alertService.error('AI did not generate any text. Please try again.');
	// 			}
	// 		},
	// 		error: (error: any) => {
	// 			this.isGeneratingAIText = false;
	// 			console.error('AI Generation Error:', error);
	// 			this.alertService.error(error.message || 'Failed to generate description. Please try again.');
	// 			this.cdr.detectChanges();
	// 		}
	// 	});
	// }

	// rewriteDescriptionWithAI() {
	// 	const taskName = this.form1.get('name')?.value || '';
	// 	if (!taskName || taskName.trim() === '') {
	// 		this.alertService.error('Please enter a task name first to generate a description.');
	// 		return;
	// 	}

	// 	this.isGeneratingAIText = true;
	// 	this.showDescriptionEditor = true; // Ensure editor is open

	// 	// Get current description as context (optional - can be used for reference)
	// 	const currentDescription = this.form1.get('description')?.value || '';

	// 	// Build full task data context for AI (includes property, reservation, assignedTo, etc.)
	// 	const taskData = {
	// 		property: this.selectedProperty || this.taskApi?.property || null,
	// 		reservation: this.selectedReservation || this.taskApi?.reservation || null,
	// 		assignedTo: this.assignedToUser || this.taskApi?.assignedTo || null,
	// 		priority: this.form1.get('priority')?.value || this.taskApi?.priority || null,
	// 		status: this.form1.get('status')?.value || this.taskApi?.status || null,
	// 		hoursEstToComplete: this.form1.get('hoursEstToComplete')?.value || this.taskApi?.hoursEstToComplete || null,
	// 		hoursActualToComplete: this.form1.get('hoursActualToComplete')?.value || this.taskApi?.hoursActualToComplete || null
	// 	};

	// 	// Generate description using AI with full task context (same as Write with AI)
	// 	// This will replace the existing description instead of appending
	// 	this.aiTextService.generateTaskDescription(taskName, currentDescription, taskData).subscribe({
	// 		next: (generatedText: string) => {
	// 			this.isGeneratingAIText = false;
	// 			if (generatedText && generatedText.trim() !== '') {
	// 				// Clean the generated text (remove any HTML tags if present, or format it)
	// 				let cleanText = generatedText.trim();
					
	// 				// Replace the entire description with the newly generated text
	// 				this.form1.patchValue({ description: '<p>' + cleanText + '</p>' });
					
	// 				this.alertService.success('Description regenerated successfully!');
	// 				this.cdr.detectChanges();
	// 			} else {
	// 				this.alertService.error('AI did not generate any text. Please try again.');
	// 			}
	// 		},
	// 		error: (error: any) => {
	// 			this.isGeneratingAIText = false;
	// 			console.error('AI Generation Error:', error);
	// 			this.alertService.error(error.message || 'Failed to generate description. Please try again.');
	// 			this.cdr.detectChanges();
	// 		}
	// 	});
	// }

	initializeTaskObject() {
		// if the data was passed in when instantiated

		if (this.taskApi) {
			// if arriving from a component include on a page
			console.log('taskApi (from @input): ' + JSON.stringify(this.taskId));
		}
		else if (this.navigationExtrasTask) {
			// if arriving from the masterTaskList
			// currently not using but keeping for reference
			this.taskApi = this.navigationExtrasTask;
			console.log('taskApi (from @navigationExtras): ' + JSON.stringify(this.taskApi));
		}
		else if (this.activatedRoute.snapshot.data.taskApiResponse) {
			// if arriving from a stand alone task call
			this.taskApiResponse = this.activatedRoute.snapshot.data.taskApiResponse; // raw

			// extract the task object
			this.taskApi = this.taskApiResponse.data.task;
			console.log('TASK (from task resolver): ' + JSON.stringify(this.taskApi));
		}
		else {
			// assume we have a valid edit or view url and just need a full refresh
			console.log((this.router.url).replace('cache-', ''));
			this.router.navigateByUrl((this.router.url).replace('cache-', ''));
		}
	}



	public findInvalidControls() {
		const invalid = [];
		const controls = this.form1.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	}

	public setFormTitle(formTitle: String) {
		this.formTitle = formTitle;
		console.log('formTitle: ' + formTitle);
	}

	openMail() {

		const dialogConfig = new MatDialogConfig();
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			inbox: this.attachedMail,
			title: 'View Inbox Mail',
			fromTask: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);
				dialogRef.close();
			});
	}

	openTaskForClone() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.width = '100vw';
		dialogConfig.height = '100vh';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.maxHeight = '100vh';
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		let passingTask: any = new Task();
		Object.assign(passingTask, this.taskApi);
		passingTask.name = '';
		passingTask.taskId = null;
		passingTask.parentTaskId = this.taskApi.taskId;
		passingTask.msgId = this.taskApi.msgId;
		passingTask.miniDoc = null;
		passingTask.jsonChildTask = null;
		dialogConfig.data = {
			title: 'Sub Task',
			isModal: true,
			taskApi: passingTask,
			purpose: 'clone',
			copyfromtaskid: this.taskApi?.taskId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				this.doaddAndDontClose.emit(data);
				console.log('Dialog output:', data);
				try {
					this.taskService.findById(this.taskApi.taskId).subscribe(
						(res: any) => {
							console.log('property-update SUCCESS: ' + JSON.stringify(res));
							this.taskApi = res?.data?.task;
							this.doUpdateAndDontClose.emit(this.taskApi);
							this.messageService.add({ severity: 'success', summary: 'Child Task Created', detail: res.message, });
						},
						(err: any) => {
							console.log('property-update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => {
						}
					);
				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.alertService.error(error);
				}

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// close the dialogBox
			});

	}
	openSendMail() {

		const dialogConfig = new MatDialogConfig();
		dialogConfig.width = '100%';
		dialogConfig.height = '100%';
		dialogConfig.maxWidth = '1600px';
		dialogConfig.maxHeight = '800px';
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'New Mail',
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.taskApi.msgId = data.msgId;
				this.form1.value.msgId = data.msgId;
				// Format dates before sending to API
				const payload = this.buildPayloadWithFormattedDates(this.form1.value);
				this.taskService.update(payload)
					.pipe(first())
					.subscribe(
						res => {
							console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
							this.alertService.success(res, true);
							this.taskApiResponse = res;
							this.taskApi = res.data.task;
							this.populateData(false);
							this.doUpdateAndDontClose.emit(this.taskApi);
						},
						err => {
							console.log('Task-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => {
							this.formLoading = false;
						});
				dialogRef.close();
			});
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});
	}
	openMailTask() {

		const dialogConfig = new MatDialogConfig();
		dialogConfig.width = '100%';
		dialogConfig.height = '100%';
		dialogConfig.maxWidth = '1600px';
		dialogConfig.maxHeight = '800px';
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		let inbox = new Inbox();
		inbox.subject = this.taskApi.name;
		inbox.senderEmail = this.taskApi?.assignedTo?.emailAddress;
		inbox.emailHtml = this.getTaskMailContent();
		inbox.emailText = this.getTaskMailContent();
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			inbox: inbox,
			title: 'Mail Task Details',
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.taskApi.msgId = data.msgId;
				this.form1.value.msgId = data.msgId;
				// Format dates before sending to API
				const payload = this.buildPayloadWithFormattedDates(this.form1.value);
				this.taskService.update(payload)
					.pipe(first())
					.subscribe(
						res => {
							console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
							this.alertService.success(res, true);
							this.taskApiResponse = res;
							this.taskApi = res.data.task;
							this.populateData(false);
							this.doUpdateAndDontClose.emit(this.taskApi);
						},
						err => {
							console.log('Task-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => {
							this.formLoading = false;
						});
				dialogRef.close();
			});
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				dialogRef.close();
			});
	}

	openReservation(reservation: any, event: any) {
		let reservationId = reservation?.reservationId;
		event.stopPropagation();
		this.openingReservation[reservationId] = true;
		this.reservationService.getOrderIdByReservationId(reservationId).pipe(first()).subscribe(
			(res: any) => {
				console.log('Order ID: ' + JSON.stringify(res));
				window.open(`https://admin.kbmhawaii.com/order/${res.data.orderId}`, '_blank');
				this.openingReservation[reservationId] = false;
			},
			(err: any) => {
				console.log('Error fetching order ID: ' + JSON.stringify(err));
				this.openingReservation[reservationId] = false;
			}
		);
	}

	getTaskMailContent() {
		let emailHTML = '<table>' +
			'<tr><th colspan="1">Task assigned</th><th colspan="5"><a href=https://admin.kbmhawaii.com/task-view/' + this.taskApi?.taskId + ' targrt=\'_blank\'>full task here</a></th></tr>' +
			'<tr><td>Task Name</td><td> ' + this.makeSafe(this.taskApi.name) + '</td></tr>' +
			'<tr><td>Due Date</td><td> ' + this.makeSafe(this.taskApi.dateDue) + '</td></tr>' +
			'<tr><td>Created By</td><td> ' + this.makeSafe(this.taskApi?.createdBy?.lastName) + ' , ' + this.makeSafe(this.taskApi?.createdBy?.firstName) + '</td></tr>' +
			'<tr><td>Owned By</td><td> ' + this.makeSafe(this.taskApi?.ownedBy?.lastName) + ' , ' + this.makeSafe(this.taskApi?.ownedBy?.firstName) + '</td></tr>' +
			'<tr><td>Due Date</td><td> ' + this.makeSafe(this.taskApi.dateDue) + '</td></tr>' +
			'<tr><td>Status</td><td> ' + this.getStatusName(this.taskApi) + '</td></tr>' +
			'<tr><td>Doc</td><td> ' + this.makeSafe(this.taskApi?.miniDoc) + '</td></tr>' +
			'</table>';
		return emailHTML;
	}
	makeSafe(val: any) {
		return val ? val : '';
	}
	getStatusName(taskApi: any) {
		if (taskApi && taskApi?.status !== undefined) {
			const status = this.statuses.find((e: any) => e.value === taskApi?.status);
			return status.name;
		} else {
			return '';
		}
	}
		onAssignedToUserSeleted(event: any) {
		if (event?.value) {
			let user = event?.value;
			console.log('onAssignedToUserSeleted - user:', user);
			// Set flag to prevent clear event from firing
			this.isSelectingAssignedToUser = true;
			
			// Create a completely new object reference with all user properties to ensure Angular detects the change
			// Preserve all properties from the original user object using spread operator
			const userCopy: any = {
				...user,
				// Ensure all required fields are present (use null for missing values to match API structure)
				userId: user.userId,
				firstName: user.firstName || null,
				lastName: user.lastName || null,
				title: user.title || null,
				emailAddress: user.emailAddress || null,
				mobilePhone: user.mobilePhone || null,
				businessPhone: user.businessPhone || null,
				businessPhoneExtension: user.businessPhoneExtension || null,
				role: user.role || null,
				companyName: user.companyName || null,
				companyStreet: user.companyStreet || null,
				companyStreet2: user.companyStreet2 || null,
				companyCity: user.companyCity || null,
				companyState: user.companyState || null,
				companyPostalCode: user.companyPostalCode || null,
				companyCountry: user.companyCountry || null,
				companyWebsite: user.companyWebsite || null,
				companyPhone: user.companyPhone || null,
				summary: user.summary || null,
				fullName: user.fullName || null
			};
			
			// Build fullName with only name (no ID or email) for display
			const nameParts = [];
			if (userCopy.lastName) nameParts.push(userCopy.lastName);
			if (userCopy.firstName) nameParts.push(userCopy.firstName);
			userCopy.fullName = nameParts.length > 0 
				? nameParts.join(' ').trim()
				: (userCopy.emailAddress || userCopy.userId?.toString() || '');
			
			// Set the assigned user - this creates a new reference
			this.assignedToUser = null; // Clear first to trigger change detection
			this.assignedToUserId = userCopy.userId;
			
			// Use setTimeout to ensure the assignment happens after the clear
			setTimeout(() => {
				this.assignedToUser = userCopy;
				// Ensure assignedToUserId is set from the user
				this.assignedToUserId = userCopy.userId;
				
				// Update form values
				this.form1.patchValue({
					userId: this.assignedToUser?.userId,
					assignedToUserId: this.assignedToUser?.userId
				});
				this.form1.value.assignedTo = this.assignedToUser;
				// Update taskApi to ensure it's in sync
				this.taskApi.assignedTo = this.assignedToUser;
				this.taskApi.assignedToUserId = this.assignedToUserId;
				
				console.log('onAssignedToUserSeleted - assignedToUser:', this.assignedToUser);
				console.log('onAssignedToUserSeleted - assignedToUserId:', this.assignedToUserId);
				console.log('onAssignedToUserSeleted - getUserDisplayName:', this.getUserDisplayName(this.assignedToUser));
				
				// Reset flag after a delay to allow selection to complete
				setTimeout(() => {
					this.isSelectingAssignedToUser = false;
				}, 200);
				
				// Force change detection
				this.cdr.detectChanges();
				this.formSave(false);
			}, 0);
			
			this.closeAssignedToUserPicker();
		}
	}
	onAssignedToUserCleared(user: any) {
		// Only clear if we're not in the middle of selecting a user
		if (!this.isSelectingAssignedToUser) {
			this.assignedToUser = null;
			this.form1.patchValue({
				userId: null,
				assignedToUserId: null
			});
			this.form1.value.assignedTo = null;
			this.assignedToUserId = null;
			this.taskApi.assignedTo = null;
			this.closeAssignedToUserPicker();
			this.cdr.detectChanges();
			this.formSave(false);
		} else {
			console.log('onAssignedToUserCleared - ignored (user selection in progress)');
		}
	}
	onRequestedByUserSeleted(user: any) {
		if (user) {
			console.log('onRequestedByUserSeleted - user:', user);
			// Set flag to prevent clear event from firing
			this.isSelectingRequestedByUser = true;
			
			// Create a completely new object reference with all user properties to ensure Angular detects the change
			// Preserve all properties from the original user object using spread operator
			const userCopy: any = {
				...user,
				// Ensure all required fields are present (use null for missing values to match API structure)
				userId: user.userId,
				firstName: user.firstName || null,
				lastName: user.lastName || null,
				title: user.title || null,
				emailAddress: user.emailAddress || null,
				mobilePhone: user.mobilePhone || null,
				businessPhone: user.businessPhone || null,
				businessPhoneExtension: user.businessPhoneExtension || null,
				role: user.role || null,
				companyName: user.companyName || null,
				companyStreet: user.companyStreet || null,
				companyStreet2: user.companyStreet2 || null,
				companyCity: user.companyCity || null,
				companyState: user.companyState || null,
				companyPostalCode: user.companyPostalCode || null,
				companyCountry: user.companyCountry || null,
				companyWebsite: user.companyWebsite || null,
				companyPhone: user.companyPhone || null,
				summary: user.summary || null,
				fullName: user.fullName || null
			};
			
			// Build fullName with only name (no ID or email) for display
			const nameParts = [];
			if (userCopy.lastName) nameParts.push(userCopy.lastName);
			if (userCopy.firstName) nameParts.push(userCopy.firstName);
			userCopy.fullName = nameParts.length > 0 
				? nameParts.join(' ').trim()
				: (userCopy.emailAddress || userCopy.userId?.toString() || '');
			
			// Set the requested by user - this creates a new reference
			this.requestedByUser = null; // Clear first to trigger change detection
			
			// Use setTimeout to ensure the assignment happens after the clear
			setTimeout(() => {
				this.requestedByUser = userCopy;
				
				// Update form values immediately
				this.form1.patchValue({
					requestedBy: this.requestedByUser
				});
				this.form1.value.requestedBy = this.requestedByUser;
				this.taskApi.requestedBy = this.requestedByUser;
				
				console.log('onRequestedByUserSeleted - requestedByUser:', this.requestedByUser);
				console.log('onRequestedByUserSeleted - getUserDisplayName:', this.getUserDisplayName(this.requestedByUser));
				
				// Force change detection
				this.cdr.detectChanges();
				
				// Save after a short delay to ensure everything is set
				setTimeout(() => {
					this.formSave(false);
					// Reset flag after save completes
					setTimeout(() => {
						this.isSelectingRequestedByUser = false;
					}, 100);
				}, 50);
			}, 0);
			
			this.closeRequestedByUserPicker();
		}
	}
	onRequestedByUserCleared(user: any) {
		// Delay the clear event to check if a selection is about to happen
		setTimeout(() => {
			// Only clear if we're not in the middle of selecting a user
			// Also check if requestedByUser is still null (meaning it was actually cleared)
			if (!this.isSelectingRequestedByUser && !this.requestedByUser) {
				this.requestedByUser = null;
				this.form1.patchValue({
					requestedBy: null
				});
				//this.requestedByUserId = null;
				this.taskApi.requestedBy = null;
				this.closeRequestedByUserPicker();
				this.cdr.detectChanges();
				this.formSave(false);
			} else {
				if (this.isSelectingRequestedByUser) {
					console.log('onRequestedByUserCleared - ignored (user selection in progress)');
				} else if (this.requestedByUser) {
					console.log('onRequestedByUserCleared - ignored (user is still selected)');
				}
			}
		}, 100);
	}

	onParentTaskSeleted(task: any) {
		if (task) {
			// Create a new object reference to ensure Angular detects the change
			const taskCopy = { ...task };
			
			// Store the selected task immediately for display
			this.selectedParentTask = null; // Clear first to trigger change detection
			setTimeout(() => {
				this.selectedParentTask = taskCopy;
				this.cdr.detectChanges();
			}, 0);
			
			// Only call API if we have a taskId (editing existing task)
			if (this.taskApi?.taskId) {
				this.taskService.addParent(this.taskApi.taskId, task.taskId).subscribe({
					next: (res) => {
						this.taskApi = res.data?.task;
						// Update selectedParentTask from API response if available, otherwise keep the selected task
						const parentTask = res.data?.task?.parentTask || res.data?.task?.parent || taskCopy;
						if (parentTask) {
							this.selectedParentTask = { ...parentTask }; // Create new reference
						} else {
							this.selectedParentTask = taskCopy;
						}
						this.alertService.success('Parent task is set', true);
						this.closeParentTaskPicker();
						this.cdr.detectChanges();
						this.doUpdateAndDontClose.emit(this.taskApi);
					},
					error: (err) => {
						console.error('Error setting parent task:', err);
						this.alertService.error(err);
						this.cdr.detectChanges();
					}
				});
			} else {
				// For new tasks, just store it and update the form
				this.form1.patchValue({ parentTaskId: task.taskId });
				this.taskApi.parentTaskId = task.taskId;
				this.closeParentTaskPicker();
				this.cdr.detectChanges();
			}
		}
	}
	private fetchParentTask(parentTaskId: number) {
		if (!parentTaskId) return;
		
		this.taskService.findById(parentTaskId).pipe(first()).subscribe({
			next: (res) => {
				if (res && res.data && res.data.task) {
					// Create a new object reference to ensure Angular detects the change
					this.selectedParentTask = { ...res.data.task };
					this.cdr.detectChanges();
					console.log('Parent task fetched:', this.selectedParentTask);
				}
			},
			error: (err) => {
				console.error('Error fetching parent task:', err);
				// Don't show error to user, just log it
			}
		});
	}

	onParentTaskCleared(user: any) {
		// Clear immediately for better UX
		this.selectedParentTask = null;
		this.form1.patchValue({ parentTaskId: null });
		this.taskApi.parentTaskId = null;
		
		// Only call API if we have a taskId (editing existing task)
		if (this.taskApi?.taskId) {
			this.taskService.deleteParent(this.taskApi.taskId).subscribe({
				next: (res) => {
					this.taskApi = res.data?.task;
					this.selectedParentTask = null;
					this.alertService.success('Parent task removed', true);
					this.closeParentTaskPicker();
					this.cdr.detectChanges();
					this.doUpdateAndDontClose.emit(this.taskApi);
				},
				error: (err) => {
					console.error('Error removing parent task:', err);
					this.alertService.error(err);
					this.cdr.detectChanges();
				}
			});
		} else {
			// For new tasks, just clear it
			this.closeParentTaskPicker();
			this.cdr.detectChanges();
		}
	}
	onAssignedToTeamSeleted(team: any) {
		if (team) {
			// Cancel any pending clear operation
			if (this.teamClearTimeout) {
				clearTimeout(this.teamClearTimeout);
				this.teamClearTimeout = null;
			}
			
			this.isSelectingTeam = true;
			console.log('onAssignedToTeamSeleted - team:', team);
			this.assignedToTeam = team;
			this.assignedToTeamId = this.assignedToTeam?.teamId;
			this.form1.patchValue({
				assignedToTeamId: this.assignedToTeam?.teamId
			});
			this.form1.value.team = this.assignedToTeam;
			this.taskApi.team = this.assignedToTeam;
			console.log('onAssignedToTeamSeleted - assignedToTeam:', this.assignedToTeam);
			this.closeAssignedToTeamPicker();
			this.cdr.detectChanges();
			this.formSave(false);
			// Reset flag after a short delay to allow any pending clear events to be ignored
			setTimeout(() => {
				this.isSelectingTeam = false;
			}, 200);
		}
	}
	onAssignedToTeamCleared(team: any) {
		// Ignore clear events that occur during team selection
		if (this.isSelectingTeam) {
			return;
		}
		
		// Cancel any existing pending clear timeout
		if (this.teamClearTimeout) {
			clearTimeout(this.teamClearTimeout);
		}
		
		// Delay the clear operation to check if a selection event is coming
		// This handles the case where PrimeNG clears the old value before selecting the new one
		this.teamClearTimeout = setTimeout(() => {
			// Only clear if we're still not selecting (selection event would have set the flag)
			if (!this.isSelectingTeam) {
				this.assignedToTeam = null;
				this.form1.patchValue({
					assignedToTeamId: null
				});
				this.form1.value.team = null;
				this.assignedToTeamId = null;
				this.taskApi.team = null;
				this.closeAssignedToTeamPicker();
				this.cdr.detectChanges();
				this.formSave(false);
			}
			this.teamClearTimeout = null;
		}, 100);
	}

	clearDueDate() {
		this.form1.value.dateDue = '';
		this.form1.patchValue({
			dateDue: ''
		});
	}

	clearFollowupDate() {
		this.form1.value.dateToFollowup = '';
		this.form1.patchValue({
			dateToFollowup: ''
		});
	}
	clearCompletedDate() {
		this.form1.value.dateCompleted = '';
		this.form1.patchValue({
			dateCompleted: ''
		});
	}

	/**
	 * Converts a date string or Date object to a Date object
	 * Handles various date formats from the API
	 */
	convertToDate(dateValue: any): Date | null {
		if (!dateValue) {
			return null;
		}
		// If it's already a Date object, return it
		if (dateValue instanceof Date) {
			return dateValue;
		}
		// If it's a string, convert it to Date
		if (typeof dateValue === 'string') {
			const date = new Date(dateValue);
			// Check if the date is valid
			if (isNaN(date.getTime())) {
				console.warn('Invalid date value:', dateValue);
				return null;
			}
			return date;
		}
		// If it's a number (timestamp), convert it
		if (typeof dateValue === 'number') {
			return new Date(dateValue);
		}
		return null;
	}

	/**
	 * Converts all date fields in a task object from strings to Date objects
	 * This is needed because PrimeNG calendar components expect Date objects
	 */
	convertTaskDates(taskData: any): any {
		if (!taskData) {
			return taskData;
		}
		const converted = { ...taskData };
		// Standard date fields
		const dateFields = [
			'dateToFollowup',
			'dateDue',
			'dateCompleted',
			'dateCreated',
			'dateLastUpdated',
			'dateAssigned',
			'dateNextAvailableVacancy',
			'eventStartDate',
			'eventEndDate'
		];
		dateFields.forEach(field => {
			if (converted[field]) {
				converted[field] = this.convertToDate(converted[field]);
			}
		});
		// Convert custom date fields (date_1 through date_7)
		for (let i = 1; i <= 7; i++) {
			const dateField = `date_${i}`;
			if (converted[dateField]) {
				converted[dateField] = this.convertToDate(converted[dateField]);
			}
		}
		return converted;
	}

	/**
	 * Formats a date value for API submission
	 * Prevents timezone shift issues by using local time components instead of UTC
	 * Preserves the original ISO format (YYYY-MM-DDTHH:mm:ss)
	 * @param value Date object or string
	 * @returns Formatted date string (YYYY-MM-DDTHH:mm:ss) or null
	 */
	private formatDateForApi(value: any): string | null {
		if (!value) return null;

		// If it's already a string, return as-is (but remove 'Z' if present to avoid timezone issues)
		if (typeof value === 'string') {
			// Remove 'Z' (UTC indicator) and milliseconds to prevent timezone conversion
			return value.replace('Z', '').replace(/\.\d{3}/g, '');
		}

		// If it's a Date object, format it using local time components (not UTC)
		// This prevents the date from shifting when serialized to JSON
		if (value instanceof Date) {
			const d = new Date(value);
			
			// Check if date is valid
			if (isNaN(d.getTime())) {
				return null;
			}

			// Use local time components to preserve the selected date
			const y = d.getFullYear();
			const m = String(d.getMonth() + 1).padStart(2, '0');
			const day = String(d.getDate()).padStart(2, '0');
			const hh = String(d.getHours()).padStart(2, '0');
			const mm = String(d.getMinutes()).padStart(2, '0');
			const ss = String(d.getSeconds()).padStart(2, '0');

			// Return in ISO format but using local time (no 'Z' suffix)
			return `${y}-${m}-${day}T${hh}:${mm}:${ss}`;
		}

		return null;
	}

	/**
	 * Builds payload with properly formatted dates for API
	 * Prevents timezone shift issues by converting Date objects to strings
	 * Preserves original ISO format but uses local time components
	 */
	private buildPayloadWithFormattedDates(formValue: any): any {
		const payload = { ...formValue };

		// All date fields - format them to preserve date and prevent timezone shift
		const dateFields = [
			'dateToFollowup',
			'dateDue',
			'dateCompleted',
			'dateCreated',
			'dateLastUpdated',
			'dateAssigned',
			'dateNextAvailableVacancy',
			'eventStartDate',
			'eventEndDate'
		];

		dateFields.forEach(field => {
			if (payload[field]) {
				payload[field] = this.formatDateForApi(payload[field]);
			}
		});

		// Custom date fields (date_1 through date_10)
		for (let i = 1; i <= 10; i++) {
			const dateField = `date_${i}`;
			if (payload[dateField]) {
				payload[dateField] = this.formatDateForApi(payload[dateField]);
			}
		}

		return payload;
	}

	close() {
		this.doDelete.emit(null);
	}

	// Dialog methods
	openEventDialog() {
		if (!this.eventDialogTemplate) {
			setTimeout(() => this.openEventDialog(), 100);
			return;
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = false; // Prevent auto-focusing the start date calendar
		dialogConfig.width = '800px';
		dialogConfig.maxWidth = '90vw';
		dialogConfig.data = { form1: this.form1 };
		
		this.eventDialogRef = this.dialog.open(this.eventDialogTemplate, dialogConfig);
	}

	closeEventDialog() {
		if (this.eventDialogRef) {
			this.eventDialogRef.close();
		}
	}

	saveEventDialog() {
		this.cdr.detectChanges();
		this.closeEventDialog();
	}

	openCategoriesDialog() {
		if (!this.taskId) {
			this.alertService.error('Please save the task first before adding categories');
			return;
		}
		if (!this.categoriesDialogTemplate) {
			setTimeout(() => this.openCategoriesDialog(), 100);
			return;
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.width = '700px';
		dialogConfig.maxWidth = '90vw';
		
		this.categoriesDialogRef = this.dialog.open(this.categoriesDialogTemplate, dialogConfig);
	}

	closeCategoriesDialog() {
		if (this.categoriesDialogRef) {
			this.categoriesDialogRef.close();
		}
	}

	openTagsDialog() {
		if (!this.taskId) {
			this.alertService.error('Please save the task first before adding tags');
			return;
		}
		if (!this.tagsDialogTemplate) {
			setTimeout(() => this.openTagsDialog(), 100);
			return;
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.width = '700px';
		dialogConfig.maxWidth = '90vw';
		this.tagsDialogRef = this.dialog.open(this.tagsDialogTemplate, dialogConfig);
		this.tagsDialogRef.afterClosed().pipe(first()).subscribe(() => {
			this.loadTaskTags(); // Refresh so summary and next open are up to date
		});
	}

	closeTagsDialog() {
		if (this.tagsDialogRef) {
			this.tagsDialogRef.close();
		}
	}

	/** Pre-load tags for this task so the Tags popup shows them immediately when opened. */
	loadTaskTags(): void {
		if (!this.taskId) return;
		const tagSource = 40;
		const tagType = 4;
		this.tagJoinService.getTagByType(tagType, tagSource, this.taskId).pipe(
			first(),
			switchMap((res: any) => {
				const tagJoins = res?.data?.tagJoin || [];
				if (tagJoins.length === 0) {
					this.taskTagList = [];
					return of([]);
				}
				return forkJoin(
					tagJoins.map((tj: any) =>
						this.tagService.findById(tj.tagId).pipe(
							first(),
							map((r: any) => {
								const t = r?.data?.tag;
								return t ? { name: t.name, visibility: t.visibility, tagType: t.tagType, tagId: t.tagId } : null;
							})
						)
					)
				);
			})
		).subscribe({
			next: (tags: any[]) => {
				this.taskTagList = Array.isArray(tags) ? tags.filter(Boolean) : [];
			},
			error: () => { this.taskTagList = []; }
		});
	}

	openCollaboratorsDialog() {
		if (!this.collaboratorsDialogTemplate) {
			setTimeout(() => this.openCollaboratorsDialog(), 100);
			return;
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.width = '700px';
		dialogConfig.maxWidth = '90vw';
		
		this.collaboratorsDialogRef = this.dialog.open(this.collaboratorsDialogTemplate, dialogConfig);
	}

	closeCollaboratorsDialog() {
		if (this.collaboratorsDialogRef) {
			this.collaboratorsDialogRef.close();
		}
	}

	openContactDialog() {
		if (!this.contactDialogTemplate) {
			setTimeout(() => this.openContactDialog(), 100);
			return;
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.width = '700px';
		dialogConfig.maxWidth = '90vw';
		
		this.contactDialogRef = this.dialog.open(this.contactDialogTemplate, dialogConfig);
	}

	closeContactDialog() {
		if (this.contactDialogRef) {
			this.contactDialogRef.close();
		}
	}

	openFilesDialog() {
		if (!this.filesDialogTemplate) {
			setTimeout(() => this.openFilesDialog(), 100);
			return;
		}
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.width = '700px';
		dialogConfig.maxWidth = '90vw';
		
		this.filesDialogRef = this.dialog.open(this.filesDialogTemplate, dialogConfig);
	}

	closeFilesDialog() {
		if (this.filesDialogRef) {
			this.filesDialogRef.close();
		}
	}

	// Summary methods
	getEventSummary(): string {
		const startDate = this.form1.get('eventStartDate')?.value;
		const startTime = this.form1.get('eventStartTime')?.value;
		const endDate = this.form1.get('eventEndDate')?.value;
		const endTime = this.form1.get('eventEndTime')?.value;
		const location = this.form1.get('eventLocation')?.value;
		const hasRepeat = this.intervalTaskRepeat && this.intervalTaskRepeat.frequency != 0;
		
		const parts: string[] = [];
		if (startDate) {
			const dateStr = this.datePipe.transform(startDate, 'shortDate');
			if (startTime) {
				parts.push(`${dateStr} ${startTime}`);
			} else {
				parts.push(dateStr);
			}
		}
		if (endDate && endDate !== startDate) {
			parts.push(' - ');
			const dateStr = this.datePipe.transform(endDate, 'shortDate');
			if (endTime) {
				parts.push(`${dateStr} ${endTime}`);
			} else {
				parts.push(dateStr);
			}
		}
		if (location) {
			parts.push(`@ ${location}`);
		}
		if (hasRepeat) {
			parts.push('[Repeat On]');
		}
		
		return parts.length > 0 ? parts.join(' ') : '';
	}

	getCategoriesSummary(): string {
		const categories: string[] = [];
		if (this.folderTagId) categories.push('Folder');
		if (this.contextTagId) categories.push('Context');
		if (this.goalTagId) categories.push('Goal');
		if (this.projectTagId) categories.push('Project');
		if (this.phaseTagId) categories.push('Phase');
		if (this.processTagId) categories.push('Process');
		return categories.length > 0 ? `${categories.length} category${categories.length > 1 ? 'ies' : 'y'}` : '';
	}

	getTagsSummary(): string {
		if (this.taskTagList && this.taskTagList.length > 0) {
			return `${this.taskTagList.length} tag${this.taskTagList.length > 1 ? 's' : ''}`;
		}
		return '';
	}

	getCollaboratorsSummary(): string {
		return this.taskUsers && this.taskUsers.length > 0 
			? `${this.taskUsers.length} collaborator${this.taskUsers.length > 1 ? 's' : ''}` 
			: '';
	}

	getContactSummary(): string {
		return this.taskUsers && this.taskUsers.length > 0 
			? `${this.taskUsers.length} contact${this.taskUsers.length > 1 ? 's' : ''}` 
			: '';
	}

	// Template methods
	loadTemplates(): void {
		this.templateService.getAll().pipe(first()).subscribe({
			next: (templates) => {
				this.templates = templates.filter(t => t.isActive);
			},
			error: (err) => {
				console.error('Error loading templates:', err);
			}
		});
	}

	onTemplateChange(templateId: number): void {
		if (templateId) {
			this.templateService.getById(templateId).pipe(first()).subscribe({
				next: (template) => {
					this.selectedTemplate = template;
					this.templateTasks = template.tasks || [];
					// Initialize subtask completions
					this.templateTasks.forEach(task => {
						if (!this.subtaskCompletions.hasOwnProperty(task.templateTaskId)) {
							this.subtaskCompletions[task.templateTaskId] = false;
						}
					});
				},
				error: (err) => {
					console.error('Error loading template:', err);
				}
			});
		} else {
			this.selectedTemplate = null;
			this.templateTasks = [];
		}
	}

	loadTaskSubtasks(): void {
		const templateId = this.form1.get('templateId')?.value;
		// if (templateId && this.taskId) {
		if (templateId) {
			this.onTemplateChange(templateId);
		}
	}

	toggleSubtaskCompletion(task: TemplateTask): void {
		this.subtaskCompletions[task.templateTaskId] = !this.subtaskCompletions[task.templateTaskId];
		// Save to localStorage (could be enhanced to save per task)
		// if (this.taskId) {
			const key = this.taskId ? `task_${this.taskId}_subtask_${task.templateTaskId}` : `template_subtask_${task.templateTaskId}`;
			localStorage.setItem(key, JSON.stringify(this.subtaskCompletions[task.templateTaskId]));
		// }
	}

	isSubtaskCompleted(task: TemplateTask): boolean {
		// if (!this.taskId) return false;
		if (!this.taskId) {
			// Return from memory if no taskId yet
			return this.subtaskCompletions[task.templateTaskId] || false;
		}
		const key = `task_${this.taskId}_subtask_${task.templateTaskId}`;
		const saved = localStorage.getItem(key);
		if (saved !== null) {
			return JSON.parse(saved);
		}
		return this.subtaskCompletions[task.templateTaskId] || false;
	}

	getFilesSummary(): string {
		return this.taskDocuments && this.taskDocuments.length > 0 
			? `${this.taskDocuments.length} file${this.taskDocuments.length > 1 ? 's' : ''}` 
			: '';
	}
}
